<template>
  <svg
    viewBox="0 0 700 400"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id="eRU21YPxKsw13-fill"
        x1="203.69"
        y1="656.96"
        x2="203.69"
        y2="242"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop id="eRU21YPxKsw13-fill-0" offset="0" stop-color="rgb(69,50,87)" />
        <stop
          id="eRU21YPxKsw13-fill-1"
          offset="0.51"
          stop-color="rgb(87,68,105)"
        />
      </linearGradient>
      <linearGradient
        id="eRU21YPxKsw19-fill"
        x1="253.4"
        y1="714.76"
        x2="414.71"
        y2="994.16"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw19-fill-0"
          offset="0.17"
          stop-color="rgb(52,165,148)"
        />
        <stop
          id="eRU21YPxKsw19-fill-1"
          offset="0.64"
          stop-color="rgb(16,77,134)"
        />
        <stop
          id="eRU21YPxKsw19-fill-2"
          offset="1"
          stop-color="rgb(40,128,143)"
        />
      </linearGradient>
      <linearGradient
        id="eRU21YPxKsw20-fill"
        x1="313.07"
        y1="959.68"
        x2="407.83"
        y2="795.55"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw20-fill-0"
          offset="0"
          stop-color="rgb(232,61,93)"
        />
        <stop
          id="eRU21YPxKsw20-fill-1"
          offset="1"
          stop-color="rgb(236,143,101)"
        />
      </linearGradient>
      <linearGradient
        id="eRU21YPxKsw23-fill"
        x1="260.81"
        y1="788.15"
        x2="485.29"
        y2="399.35"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw23-fill-0"
          offset="0.08"
          stop-color="rgb(16,77,134)"
        />
        <stop
          id="eRU21YPxKsw23-fill-1"
          offset="1"
          stop-color="rgb(52,165,148)"
        />
      </linearGradient>
      <linearGradient
        id="eRU21YPxKsw24-fill"
        x1="333.51"
        y1="805.85"
        x2="565.15"
        y2="404.63"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw24-fill-0"
          offset="0.33"
          stop-color="rgb(52,165,148)"
        />
        <stop
          id="eRU21YPxKsw24-fill-1"
          offset="1"
          stop-color="rgb(157,209,129)"
        />
      </linearGradient>
      <linearGradient
        id="eRU21YPxKsw28-fill"
        x1="315.68"
        y1="830.54"
        x2="519.8"
        y2="476.98"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw28-fill-0"
          offset="0"
          stop-color="rgb(52,165,148)"
        />
        <stop
          id="eRU21YPxKsw28-fill-1"
          offset="1"
          stop-color="rgb(157,209,129)"
        />
      </linearGradient>
      <filter
        id="eRU21YPxKsw29-filter"
        x="-400%"
        width="600%"
        y="-400%"
        height="600%"
      >
        <feGaussianBlur
          id="eRU21YPxKsw29-filter-blur-0"
          stdDeviation="10,10"
          result="result"
        />
      </filter>
      <linearGradient
        id="eRU21YPxKsw30-fill"
        x1="228.87"
        y1="877.39"
        x2="495.55"
        y2="415.49"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw30-fill-0"
          offset="0"
          stop-color="rgb(16,77,134)"
        />
        <stop
          id="eRU21YPxKsw30-fill-1"
          offset="0.5"
          stop-color="rgb(232,61,93)"
        />
        <stop
          id="eRU21YPxKsw30-fill-2"
          offset="1"
          stop-color="rgb(236,143,101)"
        />
      </linearGradient>
      <linearGradient
        id="eRU21YPxKsw31-fill"
        x1="388.67"
        y1="353.09"
        x2="213.62"
        y2="907.38"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw31-fill-0"
          offset="0"
          stop-color="rgb(74,197,119)"
        />
        <stop
          id="eRU21YPxKsw31-fill-1"
          offset="0.61"
          stop-color="rgb(40,128,143)"
        />
        <stop
          id="eRU21YPxKsw31-fill-2"
          offset="1"
          stop-color="rgb(30,69,120)"
        />
      </linearGradient>
      <filter
        id="eRU21YPxKsw33-filter"
        x="-400%"
        width="600%"
        y="-400%"
        height="600%"
      >
        <feGaussianBlur
          id="eRU21YPxKsw33-filter-blur-0"
          stdDeviation="30,30"
          result="result"
        />
      </filter>
      <filter
        id="eRU21YPxKsw34-filter"
        x="-400%"
        width="600%"
        y="-400%"
        height="600%"
      >
        <feGaussianBlur
          id="eRU21YPxKsw34-filter-blur-0"
          stdDeviation="10,10"
          result="result"
        />
      </filter>
      <filter
        id="eRU21YPxKsw35-filter"
        x="-400%"
        width="600%"
        y="-400%"
        height="600%"
      >
        <feGaussianBlur
          id="eRU21YPxKsw35-filter-blur-0"
          stdDeviation="10,10"
          result="result"
        />
      </filter>
      <linearGradient
        id="eRU21YPxKsw37-fill"
        x1="0.26"
        y1="741"
        x2="1080.26"
        y2="741"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop id="eRU21YPxKsw37-fill-0" offset="0" stop-color="rgb(45,30,59)" />
        <stop
          id="eRU21YPxKsw37-fill-1"
          offset="0.46"
          stop-color="rgb(81,63,97)"
        />
        <stop id="eRU21YPxKsw37-fill-2" offset="1" stop-color="rgb(45,30,59)" />
      </linearGradient>
      <linearGradient
        id="eRU21YPxKsw43-fill"
        x1="770.84"
        y1="667.88"
        x2="833.72"
        y2="704.19"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw43-fill-0"
          offset="0.49"
          stop-color="rgb(66,50,82)"
        />
        <stop id="eRU21YPxKsw43-fill-1" offset="1" stop-color="rgb(81,63,97)" />
      </linearGradient>
      <linearGradient
        id="eRU21YPxKsw45-fill"
        x1="822.73"
        y1="773.39"
        x2="928.26"
        y2="773.39"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop id="eRU21YPxKsw45-fill-0" offset="0" stop-color="rgb(69,50,87)" />
        <stop
          id="eRU21YPxKsw45-fill-1"
          offset="0.51"
          stop-color="rgb(87,68,105)"
        />
      </linearGradient>
      <filter
        id="eRU21YPxKsw49-filter"
        x="-400%"
        width="600%"
        y="-400%"
        height="600%"
      >
        <feGaussianBlur
          id="eRU21YPxKsw49-filter-blur-0"
          stdDeviation="10,10"
          result="result"
        />
      </filter>
      <linearGradient
        id="eRU21YPxKsw50-fill"
        x1="483.17"
        y1="663.26"
        x2="526.3"
        y2="588.56"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw50-fill-0"
          offset="0"
          stop-color="rgb(52,165,148)"
        />
        <stop
          id="eRU21YPxKsw50-fill-1"
          offset="1"
          stop-color="rgb(157,209,129)"
        />
      </linearGradient>
      <linearGradient
        id="eRU21YPxKsw51-fill"
        x1="544.47"
        y1="580.19"
        x2="464.99"
        y2="661.39"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw51-fill-0"
          offset="0"
          stop-color="rgb(40,128,143)"
        />
        <stop
          id="eRU21YPxKsw51-fill-1"
          offset="1"
          stop-color="rgb(52,165,148)"
        />
      </linearGradient>
      <linearGradient
        id="eRU21YPxKsw52-fill"
        x1="419.29"
        y1="686.11"
        x2="645.52"
        y2="686.11"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw52-fill-0"
          offset="0"
          stop-color="rgb(52,165,148)"
        />
        <stop
          id="eRU21YPxKsw52-fill-1"
          offset="1"
          stop-color="rgb(157,209,129)"
        />
      </linearGradient>
      <filter
        id="eRU21YPxKsw55-filter"
        x="-400%"
        width="600%"
        y="-400%"
        height="600%"
      >
        <feGaussianBlur
          id="eRU21YPxKsw55-filter-blur-0"
          stdDeviation="10,10"
          result="result"
        />
      </filter>
      <linearGradient
        id="eRU21YPxKsw56-fill"
        x1="310.29"
        y1="693.43"
        x2="353.42"
        y2="618.73"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw56-fill-0"
          offset="0"
          stop-color="rgb(52,165,148)"
        />
        <stop
          id="eRU21YPxKsw56-fill-1"
          offset="1"
          stop-color="rgb(157,209,129)"
        />
      </linearGradient>
      <linearGradient
        id="eRU21YPxKsw57-fill"
        x1="364.66"
        y1="662.21"
        x2="281.58"
        y2="620.93"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw57-fill-0"
          offset="0"
          stop-color="rgb(40,128,143)"
        />
        <stop
          id="eRU21YPxKsw57-fill-1"
          offset="1"
          stop-color="rgb(52,165,148)"
        />
      </linearGradient>
      <linearGradient
        id="eRU21YPxKsw58-fill"
        x1="253.35"
        y1="678.6"
        x2="427.66"
        y2="678.6"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw58-fill-0"
          offset="0"
          stop-color="rgb(52,165,148)"
        />
        <stop
          id="eRU21YPxKsw58-fill-1"
          offset="1"
          stop-color="rgb(157,209,129)"
        />
      </linearGradient>
      <linearGradient
        id="eRU21YPxKsw68-fill"
        x1="622.84"
        y1="643.63"
        x2="740.28"
        y2="440.23"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw68-fill-0"
          offset="0.08"
          stop-color="rgb(52,165,148)"
        />
        <stop
          id="eRU21YPxKsw68-fill-1"
          offset="1"
          stop-color="rgb(157,209,129)"
        />
      </linearGradient>
      <linearGradient
        id="eRU21YPxKsw69-fill"
        x1="570.17"
        y1="638.12"
        x2="681.52"
        y2="445.26"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw69-fill-0"
          offset="0.08"
          stop-color="rgb(40,128,143)"
        />
        <stop
          id="eRU21YPxKsw69-fill-1"
          offset="0.84"
          stop-color="rgb(74,197,119)"
        />
      </linearGradient>
      <linearGradient
        id="eRU21YPxKsw70-fill"
        x1="678.49"
        y1="504.22"
        x2="572.39"
        y2="313.23"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw70-fill-0"
          offset="0.25"
          stop-color="rgba(39,130,233,0)"
        />
        <stop
          id="eRU21YPxKsw70-fill-1"
          offset="0.78"
          stop-color="rgb(39,130,233)"
        />
      </linearGradient>
      <linearGradient
        id="eRU21YPxKsw71-stroke"
        x1="677.11"
        y1="596.49"
        x2="828.37"
        y2="596.49"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="eRU21YPxKsw71-stroke-0"
          offset="0"
          stop-color="rgb(40,128,143)"
        />
        <stop
          id="eRU21YPxKsw71-stroke-1"
          offset="0.26"
          stop-color="rgb(52,165,148)"
        />
        <stop
          id="eRU21YPxKsw71-stroke-2"
          offset="1"
          stop-color="rgb(40,128,143)"
        />
      </linearGradient>
      <filter
        id="eRU21YPxKsw75-filter"
        x="-400%"
        width="600%"
        y="-400%"
        height="600%"
      >
        <feGaussianBlur
          id="eRU21YPxKsw75-filter-blur-0"
          stdDeviation="10,10"
          result="result"
        />
      </filter>
      <radialGradient
        id="eRU21YPxKsw76-fill"
        cx="0"
        cy="0"
        r="78.27"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1 0 0 1 -12.13 -17.81)"
      >
        <stop
          id="eRU21YPxKsw76-fill-0"
          offset="0"
          stop-color="rgb(173,214,146)"
        />
        <stop
          id="eRU21YPxKsw76-fill-1"
          offset="0.5"
          stop-color="rgb(140,186,166)"
        />
        <stop
          id="eRU21YPxKsw76-fill-2"
          offset="1"
          stop-color="rgb(236,143,101)"
        />
      </radialGradient>
      <filter
        id="eRU21YPxKsw80-filter"
        x="-400%"
        width="600%"
        y="-400%"
        height="600%"
      >
        <feGaussianBlur
          id="eRU21YPxKsw80-filter-blur-0"
          stdDeviation="30,30"
          result="result"
        />
      </filter>
      <filter
        id="eRU21YPxKsw81-filter"
        x="-400%"
        width="600%"
        y="-400%"
        height="600%"
      >
        <feGaussianBlur
          id="eRU21YPxKsw81-filter-blur-0"
          stdDeviation="30,30"
          result="result"
        />
      </filter>
    </defs>
    <g
      id="eRU21YPxKsw3"
      transform="matrix(0.470183, 0, 0, 0.470183, 107.805817, -90.853477)"
    >
      <g
        id="eRU21YPxKsw4_tr"
        transform="translate(141.897434,772.022303) rotate(0)"
      >
        <g id="eRU21YPxKsw4" transform="translate(-141.897434,-772.022303)">
          <g
            id="eRU21YPxKsw5_tr"
            transform="translate(193.794972,651.507014) rotate(0)"
          >
            <g id="eRU21YPxKsw5" transform="translate(-193.794972,-651.507014)">
              <g id="eRU21YPxKsw6">
                <path
                  id="eRU21YPxKsw7"
                  d="M390.26,309C397.26,313,363.26,415,345.26,452C327.26,489,210.38,626.76,203.26,634C196.14,641.24,195.26,639,198.26,631C204.48,614.41,288.26,381,316.26,353C344.26,325,383.26,305,390.26,309Z"
                  fill="rgb(69,50,87)"
                  stroke="none"
                  stroke-width="1"
                />
                <path
                  id="eRU21YPxKsw8"
                  d="M314.26,417C302.26,435,257.26,535,212.26,613C325.26,488,372.26,339,372.26,339"
                  fill="none"
                  stroke="rgb(87,68,105)"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <g
                id="eRU21YPxKsw9_tr"
                transform="translate(190.51079,642.81881) rotate(0)"
              >
                <g
                  id="eRU21YPxKsw9"
                  transform="translate(-190.51079,-642.81881)"
                >
                  <path
                    id="eRU21YPxKsw10"
                    d="M73.26,427C80.85,423.21,132.26,473,151.26,499C170.26,525,198.26,581,198.26,598C198.26,615,197.74,650.27,196.5,654.13C195.26,657.99,188.26,659,188.26,654C188.26,649,190.26,626,184.26,614C178.26,602,123.26,546,103.26,519C83.26,492,65.26,431,73.26,427Z"
                    fill="rgb(69,50,87)"
                    stroke="none"
                    stroke-width="1"
                  />
                  <path
                    id="eRU21YPxKsw11"
                    d="M114.26,503C114.26,503,174.48,574.22,198.26,598C157.26,519,100.26,473,100.26,473"
                    fill="none"
                    stroke="rgb(87,68,105)"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </g>
              <g
                id="eRU21YPxKsw12_tr"
                transform="translate(192.970695,653.486657) rotate(0)"
              >
                <g
                  id="eRU21YPxKsw12"
                  transform="translate(-192.970695,-653.486657)"
                >
                  <path
                    id="eRU21YPxKsw13"
                    d="M198.26,242C205.26,242,210.26,293,230.26,335C250.26,377,274.26,524,240.26,575C206.26,626,202.26,640,198.26,656C191.26,659,188.26,654,188.26,654C188.26,654,197.26,629,187.26,590C177.26,551,143.26,431,151.26,373C159.26,315,188.26,242,198.26,242Z"
                    fill="url(#eRU21YPxKsw13-fill)"
                    stroke="none"
                    stroke-width="1"
                  />
                  <path
                    id="eRU21YPxKsw14"
                    d="M216.26,357C216.26,389,259.26,517,205.26,603C221.26,513,189.26,380,193.26,321"
                    fill="none"
                    stroke="rgb(102,83,117)"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    id="eRU21YPxKsw15"
                    d="M175.26,390C175.26,421,182.26,496,196.26,560"
                    fill="none"
                    stroke="rgb(102,83,117)"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </g>
            </g>
          </g>
          <path
            id="eRU21YPxKsw16"
            d="M103.26,797C103.26,797,167.26,717,178.26,690C189.26,663,186.26,646,194.26,643C202.26,640,197.26,673,194.26,686C191.26,699,156.26,785,156.26,785Z"
            fill="rgb(59,41,74)"
            stroke="none"
            stroke-width="1"
          />
        </g>
      </g>
      <g
        id="eRU21YPxKsw17_ts"
        transform="translate(575.51,653.326828) scale(1,1)"
      >
        <g id="eRU21YPxKsw17" transform="translate(-575.66362,-654.006056)">
          <g id="eRU21YPxKsw18">
            <path
              id="eRU21YPxKsw19"
              d="M278.26,766C278.26,856,299.26,938,375.26,913C405.07,903.19,414.01,877.85,410.26,855C406.6,832.7,386.74,814.71,360.51,821.4C331.91,828.7,329.69,852.24,339.26,866C344.9,874.12,355.17,878.83,364.26,876C369.71,874.3,380.26,868.84,380.26,860C380.26,851,370.63,845,361.26,850C349.76,856.17,335.61,841.5,356.26,833C373.26,826,391.26,831,398.26,849C405.03,866.42,399.8,891.86,372.26,901.64C340.26,913,314.45,895.01,306.26,870C297.34,842.72,306.58,808,337.26,794C384.11,772.54,424.64,795.35,442.26,837C453.26,863,449.19,929.63,387.26,950C311.26,975,226.26,948,203.26,781C200.41,760.29,211.26,737,237.26,734C264.37,730.87,278.26,737,278.26,766Z"
              fill="url(#eRU21YPxKsw19-fill)"
              stroke="none"
              stroke-width="1"
            />
            <path
              id="eRU21YPxKsw20"
              d="M381,821.18L381,821.18C389.18,815.51,398.54,800.44,397.38,790.42C407.699483,794.530939,416.959135,800.915964,424.47,809.1C421.47,820.47,403.38,830.82,399.13,832.03L399.13,832.03C394.247224,826.755679,387.955722,822.990495,381,821.18ZM379.8,856.7C385.8,856.26,394.37,850.08,395.91,844.12C392.669479,838.379225,387.484506,833.98512,381.29,831.73C381.29,838.92,374.89,850.11,374.89,850.11C377.277942,851.631819,379.024895,853.976508,379.8,856.7ZM248.86,910.29C248.799506,910.453337,248.749406,910.620337,248.71,910.79C257.079536,922.171833,267.321929,932.049031,279,940L279.7,940C280.7,927.26,296.89,901.4,309.85,899.73C303.593576,892.4914,298.554613,884.284511,294.93,875.43L294.93,875.43C284.8,874.28,256.81,888.83,248.86,910.29ZM410.59,872.11C409.820273,878.225132,407.924998,884.1449,405,889.57C411.31,895.92,426.36,903.88,439.76,902.03C443.973043,891.698244,446.397635,880.725021,446.93,869.58C436.37,876.22,417.8,876.5,410.59,872.11ZM308.43,823.28C321.57,817.35,338.95,827.5,338.95,834.73L338.95,834.73C341.828559,830.787429,345.597514,827.580392,349.95,825.37L349.95,825.37C349.95,809.77,336.81,798.48,329.16,798.47C320.000283,804.565904,312.800626,813.18257,308.43,823.28ZM369.33,873.89L369.33,873.89C367.7029,874.735851,366.006783,875.44173,364.26,876C362.317642,876.594987,360.290394,876.865287,358.26,876.8L358.26,876.8C354.46,880.59,356.7,897.34,363.42,904.06C366.40616,903.464536,369.344178,902.648977,372.21,901.62C378.480427,899.499904,384.222995,896.059138,389.05,891.53C388.992239,891.122934,388.806645,890.744743,388.52,890.45C379.38,895.4,369.33,881.76,369.33,873.89ZM376.05,953.28C368.36,945.85,360.64,926.56,364.59,915.89C356.242641,917.794035,347.602838,918.042051,339.16,916.62C333.93,924.26,332.04,942.01,339.39,958.05C351.763756,958.035091,364.084424,956.431992,376.05,953.28ZM339.26,866C337.459739,863.374555,336.108015,860.468349,335.26,857.4L335.26,857.4C335.26,857.4,315.53,855.99,306.26,870C308.249585,876.124756,311.329011,881.839818,315.35,886.87C317.49,875.32,339.26,866,339.26,866Z"
              fill="url(#eRU21YPxKsw20-fill)"
              stroke="none"
              stroke-width="1"
            />
          </g>
          <g id="eRU21YPxKsw21">
            <g id="eRU21YPxKsw22">
              <path
                id="eRU21YPxKsw23"
                d="M596.75,469.23C593.5,467.32,588.63,464.45,582.9,461.11C577.51,454.81,569.34,446.76,560.16,442.94C556.022372,441.340752,551.586991,440.658386,547.16,440.94C540.444739,437.212561,533.531133,433.854238,526.45,430.88C521.05,428.81,515.03,428.98,509.73,429.93C504.133892,427.07159,498.302425,424.699525,492.3,422.84C479.91,419.18,472.16,421.76,467.56,425.09C458.24,422.46,448.18,420.3,440.16,420.3C430.356434,420.42797,420.867801,423.78062,413.16,429.84C402.720852,428.541871,392.135207,429.076567,381.88,431.42C373.963892,433.321032,366.76328,437.462945,361.14,443.35C348.14,446.25,336.14,449.89,331.41,454.08C325.967663,458.894157,321.573338,464.775949,318.5,471.36C310.7,474.92,301.96,479.36,295.97,483.82C291.203746,487.447816,288.085694,492.830595,287.31,498.77C279.38,504.57,272.13,510.11,269.21,513.03C265.14,517.1,262.02,525.77,259.96,533.17C250.658091,540.856517,244.299042,551.522055,241.96,563.36C236.24,570.49,229.89,579.22,228.03,584.87C225.03,593.87,226.43,597.93,226.43,597.93C226.43,597.93,218.94,606.93,217.33,612.05C216.18,615.72,217.33,621.79,217.33,621.79C217.33,621.79,212.1,633.29,210.84,637.9C210.136053,641.196168,210.136053,644.603832,210.84,647.9C211.543947,651.196168,207.39,655.2,206.13,659.01C204.87,662.82,207.41,668.82,207.41,668.82C207.41,668.82,203.51,674.34,202.67,678.82C201.83,683.3,204.67,688.71,204.67,688.71C204.67,688.71,201.39,700.16,201.39,703.62C201.39,707.08,203.61,714.21,203.61,714.21C202.058554,717.886179,201.096733,721.784086,200.76,725.76C200.57,727.83,201.23,731.98,201.94,733.19C201.53,738.05,201.17,741.71,201.17,744.82C201.30523,747.991139,201.639219,751.150674,202.17,754.28C202.700781,757.409326,225.79,672.56,237.47,633.16C243.74,612.03,247.47,590.01,249.62,574.16C274.62,554.47,340.14,504.99,385.88,488.74C429.83,473.13,550.03,483.33,580.66,478.13C585.31,477.34,587.52,475.34,588.57,473.49C591.445184,472.375479,594.188481,470.946818,596.75,469.23Z"
                fill="url(#eRU21YPxKsw23-fill)"
                stroke="none"
                stroke-width="1"
              />
              <path
                id="eRU21YPxKsw24"
                d="M461.76,432C358.67,429.42,293.38,480.7,243.25,568.47C193.57,655.47,203.25,781.05,203.25,781.05L277.79,757.34C277.26,745,281.26,722,301.26,714C360.77,695,381.26,711,545.26,672C628,652.32,699.87,626.86,671.63,567.64C636.68,494.36,572.38,434.71,461.76,432Z"
                fill="url(#eRU21YPxKsw24-fill)"
                stroke="none"
                stroke-width="1"
              />
              <g id="eRU21YPxKsw25">
                <path
                  id="eRU21YPxKsw26"
                  d="M409.72,628.84C348.72,642.84,316.59,664.33,296.26,684.66C272.26,708.66,266.26,762.57,266.26,762.57C271.54,760.89,272.02,759.13,277.8,757.29C277.26,745,281.26,722,301.26,714C360.77,695,381.26,711,545.26,672C615,655.42,677,634.73,677.87,593.21C591,598.42,458.39,617.7,409.72,628.84Z"
                  opacity="0.5"
                  fill="rgb(209,181,153)"
                  stroke="none"
                  stroke-width="1"
                />
                <path
                  id="eRU21YPxKsw27"
                  d="M368.29,661.69C273.52,692.97,266.29,762.57,266.29,762.57C271.57,760.89,272.05,759.13,277.83,757.29C277.26,745,281.26,722,301.26,714C360.77,695,381.26,711,545.26,672C615,655.42,677,634.73,677.87,593.21C544.63,667.65,421.46,644.15,368.29,661.69Z"
                  fill="rgb(209,181,153)"
                  stroke="none"
                  stroke-width="1"
                />
              </g>
              <path
                id="eRU21YPxKsw28"
                d="M249.21,786.34C250.87,767.22,231.48,752.04,230.37,732.52C229.76,721.64,231.91,715.07,237.57,706.22C243.23,697.37,252.83,691.92,257.22,682.04C265.04,664.4,258.75,643.68,267.13,626.04C279.28,600.45,301.92,604.65,324.71,595.86C345,588,348.13,570.8,356.06,552.7C366.28,529.39,387.06,512.35,413.65,517.43C439.37,522.35,457.96,550.43,485.65,541.43C509.65,533.68,525.99,505.05,553.56,508.26C585.73,512.01,608.28,550.1,635.34,564.58L634.34,567.5C608.81,562.03,590.25,541.07,566.02,533.44C537.16,524.34,521.64,559.56,496.68,570.56C465.77,584.2,444.52,568.01,419.05,552.43C391.88,535.8,382.97,554.7,371.16,577.36C360.16,598.36,342.81,611.21,319.55,615.36C290.55,620.59,281.79,623.54,277.02,653.12C274.77,667.12,274.84,680.58,267.02,692.99C260.55,703.24,247.53,709.3,242.83,720.37C235.18,738.45,260.93,779.07,249.21,786.34Z"
                fill="url(#eRU21YPxKsw28-fill)"
                stroke="none"
                stroke-width="1"
              />
              <path
                id="eRU21YPxKsw29"
                d="M185.76,768.45L720.52,666.6C720.52,666.6,696.68,617.94,645.52,632.08C574.52,651.7,490.44,667.84,398.52,676.37C306.6,684.9,185.76,727.81,185.76,768.45Z"
                opacity="0.3"
                filter="url(#eRU21YPxKsw29-filter)"
                fill="rgb(60,22,72)"
                stroke="none"
                stroke-width="1"
              />
            </g>
            <path
              id="eRU21YPxKsw30"
              d="M255.18,548.7C271.92,522.6,290.38,500.33,311.28,482.46C319.42,515.29,341.28,553.24,341.28,572.33C341.32,592.07,275.77,585.62,255.18,548.7ZM247.18,675.51C236.9,672.08,220.93,666.51,210.68,662.92C207.327714,681.166409,205.023936,699.589951,203.78,718.1C209.5,719.1,218.02,719.28,228.73,715.5C249.29,708.25,263.31,680.91,247.17,675.51ZM273.93,614.3C261.86,607.91,246.48,600.49,233.21,588.3C229.71,596.08,226.59,604.06,223.83,612.12C229.13,616.86,237.83,623.18,252.15,630.48C283.67,646.59,294.68,625.29,273.92,614.3ZM461.76,432C445.26736,431.51382,428.765947,432.602082,412.48,435.25C413.06,475.45,437.21,533.82,452.48,558.64C468.88,585.22,489.75,596.88,486.41,576.87C483.07,556.86,464.78,495,480.57,506.3C496.36,517.6,511.17,513.99,509.87,506.25C508.68,499.12,505.26,458.54,507.87,436.78C492.6571,433.924809,477.23508,432.326083,461.76,432ZM563.13,555.58C559.04,529.91,555.2,482.13,564.21,455.13C554.718625,450.578136,544.913564,446.711586,534.87,443.56C530.54,474.96,536.16,568.02,544.62,584.86C554,603.64,567.84,585.11,563.13,555.58ZM495.29,529.72C497.23,539.51,505.29,540.33,509.95,533.25C514.61,526.17,492.68,516.58,495.29,529.72ZM400.7,581.27C421,607.76,434.47,608.83,426,594.6C418.07,581.25,380.44,489.35,375.84,444.66C363.920281,448.918599,352.434752,454.306417,341.54,460.75C352.82,497,383.67,559,400.7,581.27ZM211.33,824.48C215.568634,842.734316,221.577061,860.531853,229.27,877.62C232.82,876.91,239.09,874.34,243.48,865.27C249.94,851.93,244.92,832.03,230.42,827.95C224.143525,826.358058,217.765211,825.198668,211.33,824.48Z"
              fill="url(#eRU21YPxKsw30-fill)"
              stroke="none"
              stroke-width="1"
            />
            <path
              id="eRU21YPxKsw31"
              d="M243.73,632.26C247.2,631.39,256.38,637.58,253.73,640.26C251.08,642.94,242.41,646.92,240.42,644.92C238.43,642.92,238.4,633.59,243.73,632.26ZM220.78,726.18C220.92,733.25,207.5,734.23,207.39,728.57C207.28,722.91,220.72,723.36,220.78,726.18ZM364.85,610.87C357.25,608.79,360.43,595.69,369.07,596.77C374.71,597.48,372.6,613,364.85,610.87ZM257.64,666.72C255.37,675.05,236.57,672.61,239.47,662.94C241.74,655.37,259.91,658.39,257.64,666.72ZM254.28,724.72C247.62,729.51,245.55,722.72,248.74,718.59C253.7,712.24,260.94,720,254.28,724.75ZM246.28,810.27C244.88,802.33,224.57,803.04,225.09,810.09C225.81,820,247.67,818.24,246.28,810.3ZM254.54,874.91C259.36,880.81,271.97,866.76,267.42,861.83C262.87,856.9,249.72,869.05,254.54,874.94Z"
              fill="url(#eRU21YPxKsw31-fill)"
              stroke="none"
              stroke-width="1"
            />
            <path
              id="eRU21YPxKsw32"
              d="M490.4,482.56C497.49,480.92,506.09,499.71,498.4,503.56C488.4,508.56,477.4,485.56,490.4,482.56ZM425.34,446.56C428.45,444.11,441.98,450.63,442.46,465.13C442.85,477,431.84,483.31,427.07,478.85C422.3,474.39,415.69,454.12,425.34,446.54ZM315.45,547.67C319.9,544.25,332.12,561.74,325.56,565.5C317.24,570.25,307.73,553.61,315.45,547.67ZM305.35,521.52C308.95,519.35,313.08,517.95,314.26,520.92C315.44,523.89,313.08,535.18,308.92,535.78C304.76,536.38,302.38,523.3,305.35,521.52ZM550.45,562.86C548.21,566.29,545.54,566.8,543.66,564.7C539.72,560.32,539.26,549.95,544.41,548.7C549.83,547.5,554.73,556.32,550.45,562.86Z"
              opacity="0.5"
              fill="rgb(255,194,133)"
              stroke="none"
              stroke-width="1"
            />
          </g>
          <path
            id="eRU21YPxKsw33"
            display="none"
            d="M272.016269,912.412061C204.525211,828.838296,222.126974,684.007053,262.156974,598.147053C308.716974,498.257053,413.168275,430.986579,523.428275,465.046579C573.228275,480.426579,614.12,514.79,638.84,561.06C680,638.09,533.048685,629.076641,463.040097,619.098053C387.591508,612.614288,370.844447,580.500112,281.875563,652.373172C242.115563,698.643172,228.829387,842.479001,272.016269,912.412061Z"
            opacity="0"
            filter="url(#eRU21YPxKsw33-filter)"
            fill="rgb(1,237,255)"
            stroke="none"
            stroke-width="1"
          />
          <path
            id="eRU21YPxKsw34"
            d="M572,454.09C572.69,466.25,576.2,482.27,582.71,488.78C565.71,537.78,567.71,609.78,597.71,632.78C601.76,635.89,609.48,642.31,616.95,648.25C668.7,630.1,701.78,604.84,681.08,561.42C659.44,516.11,620,481,572,454.09Z"
            opacity="0.4"
            filter="url(#eRU21YPxKsw34-filter)"
            fill="rgb(60,22,72)"
            stroke="none"
            stroke-width="1"
          />
        </g>
      </g>
      <path
        id="eRU21YPxKsw35"
        d="M202.6,744.37C202.6,744.37,199.28,775.91,211.26,823.29C260.67,815.51,279.99,807.91,279.99,807.91C279.99,807.91,274.06,750.26,286.34,725.83C234.43,725.83,202.6,744.37,202.6,744.37Z"
        opacity="0.4"
        filter="url(#eRU21YPxKsw35-filter)"
        fill="rgb(60,22,72)"
        stroke="none"
        stroke-width="1"
      />
      <g id="eRU21YPxKsw36">
        <path
          id="eRU21YPxKsw37"
          d="M0.26,804C443.26,674,804.26,630,1080.26,616L1080.26,666C727.26,677,276.26,770,0.26,866Z"
          fill="url(#eRU21YPxKsw37-fill)"
          stroke="none"
          stroke-width="1"
        />
        <g
          id="eRU21YPxKsw38_tr"
          transform="translate(777.682246,676.750734) rotate(0)"
        >
          <g id="eRU21YPxKsw38" transform="translate(-777.682246,-676.750734)">
            <g
              id="eRU21YPxKsw39_tr"
              transform="translate(840.024166,691.329757) rotate(-1.728843)"
            >
              <g
                id="eRU21YPxKsw39"
                transform="translate(-840.024166,-691.329757)"
              >
                <path
                  id="eRU21YPxKsw40"
                  d="M838.21,688.86C838.21,688.86,851,690,858.08,690.41C864.36,689.67,879.73,679.58,897.52,687.35C915.31,695.12,950.64,775.98,952.12,788.54C953.6,801.1,916.12,750.44,888.59,730.44C861.06,710.44,861.59,698.28,855.68,697.06C849.77,695.84,838.26,692.43,838.26,692.43Z"
                  fill="rgb(69,50,87)"
                  stroke="none"
                  stroke-width="1"
                />
                <path
                  id="eRU21YPxKsw41"
                  d="M872.26,699C872.26,699,908.26,721,922.26,749"
                  fill="none"
                  stroke="rgb(87,68,105)"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </g>
            <path
              id="eRU21YPxKsw42"
              d="M830.79,693.52C845.64,699.82,846.71,685.66,827.79,680.45C829.75,685,830.79,693.52,830.79,693.52Z"
              fill="rgb(69,50,87)"
              stroke="none"
              stroke-width="1"
            />
            <path
              id="eRU21YPxKsw43"
              d="M762,687C784.66,691.43,812.37,714.5,828.13,708.14C843.89,701.78,834.41,677.63,815.13,669.54C795.85,661.45,760.73,670.79,762,687Z"
              fill="url(#eRU21YPxKsw43-fill)"
              stroke="none"
              stroke-width="1"
            />
            <g
              id="eRU21YPxKsw44_tr"
              transform="translate(824.840516,700.763208) rotate(0)"
            >
              <g
                id="eRU21YPxKsw44"
                transform="translate(-824.840516,-700.763208)"
              >
                <path
                  id="eRU21YPxKsw45"
                  d="M823.26,705C821.26,703,825.26,696,829.26,700C833.26,704,829.26,707,841.26,712C853.26,717,895.26,712,927.26,781C925.26,806,928.26,848,928.26,848C928.26,848,873.44,828.18,847.26,786C835.158891,766.50427,828.91126,743.94338,829.26,721C829.26,712,823.26,705,823.26,705Z"
                  fill="url(#eRU21YPxKsw45-fill)"
                  stroke="none"
                  stroke-width="1"
                />
                <path
                  id="eRU21YPxKsw46"
                  d="M916.26,787C916.26,787,879.26,728,857.26,728L920.26,819"
                  fill="none"
                  stroke="rgb(102,83,117)"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  id="eRU21YPxKsw47"
                  d="M842.26,725C842.26,741,858.26,793,905.26,819"
                  fill="none"
                  stroke="rgb(102,83,117)"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g id="eRU21YPxKsw48">
        <path
          id="eRU21YPxKsw49"
          d="M294.84,647.08C317.84,626.58,347.26,620.8,368.48,636C390.99,652.13,384.92,682.11,366.01,698.6C347.1,715.09,314.44,724,290.21,707C274.48,696,270.44,668.85,294.84,647.08Z"
          transform="matrix(1 0 0 1 167.290073 -38.950899)"
          opacity="0.4"
          filter="url(#eRU21YPxKsw49-filter)"
          fill="rgb(60,22,72)"
          stroke="none"
          stroke-width="1"
        />
        <path
          id="eRU21YPxKsw50"
          d="M459,638C459,638,452.26,608.78,486,593C519.74,577.22,547.81,594.13,550.06,618.85C552.31,643.57,532.27,661.91,491.58,661.68C470.25,661.57,461.26,649.21,459,638Z"
          fill="url(#eRU21YPxKsw50-fill)"
          stroke="none"
          stroke-width="1"
        />
        <path
          id="eRU21YPxKsw51"
          d="M488.26,674C498.75,667.28,516.26,658,527.26,643C534.79,632.74,521.89,605.25,501.26,609C484.77,612,457.72,627,432.26,649C410.01,668.24,414.4,689.79,421.83,696.4C429.26,703.01,466.53,687.92,488.26,674Z"
          fill="url(#eRU21YPxKsw51-fill)"
          stroke="none"
          stroke-width="1"
        />
        <path
          id="eRU21YPxKsw52"
          d="M422.26,684C411.08,695.18,433.26,709,459.26,709L545.26,709C550.26,720.56,578.26,718.94,605.09,712.12C624.52,707.18,643.15,705.01,644.9,698C648.9,682,632.26,681,632.26,681C632.26,681,649.26,673.74,640.06,665.63C620.22,648.2,579.26,654,557.26,667C490.26,658,454.26,652,422.26,684Z"
          fill="url(#eRU21YPxKsw52-fill)"
          stroke="none"
          stroke-width="1"
        />
        <path
          id="eRU21YPxKsw53"
          d="M632.26,681C632.26,681,618.26,672.66,586.82,681.8C603.11,668.58,628.65,669.72,642.1,673.3C639,678.4,632.26,681,632.26,681Z"
          opacity="0.2"
          fill="rgb(60,22,72)"
          stroke="none"
          stroke-width="1"
        />
      </g>
      <g id="eRU21YPxKsw54">
        <path
          id="eRU21YPxKsw55"
          d="M294.84,647.08C317.84,626.58,347.26,620.8,368.48,636C390.99,652.13,384.92,682.11,366.01,698.6C347.1,715.09,314.44,724,290.21,707C274.48,696,270.44,668.85,294.84,647.08Z"
          opacity="0.4"
          filter="url(#eRU21YPxKsw55-filter)"
          fill="rgb(60,22,72)"
          stroke="none"
          stroke-width="1"
        />
        <path
          id="eRU21YPxKsw56"
          d="M286.13,668.14C286.13,668.14,279.38,638.92,313.13,623.14C346.88,607.36,374.95,624.27,377.2,648.99C379.45,673.71,359.4,692.05,318.72,691.82C297.37,691.74,288.38,679.38,286.13,668.14Z"
          fill="url(#eRU21YPxKsw56-fill)"
          stroke="none"
          stroke-width="1"
        />
        <path
          id="eRU21YPxKsw57"
          d="M275.72,578.61C303.36,572.22,348.26,633,353.26,646C358.26,659,361.26,678,339.26,685C317.26,692,270.4,661.12,258.4,628.12C250.6,606.69,258,582.72,275.72,578.61Z"
          fill="url(#eRU21YPxKsw57-fill)"
          stroke="none"
          stroke-width="1"
        />
        <path
          id="eRU21YPxKsw58"
          d="M384.5,707.07L412.6,701.28C412.6,701.28,405.72,687.58,384.5,682.77C374.36,680.48,363.01,684.44,356.83,683C343.11,658.41,315.38,612,303.26,591C288.26,565,246.97,580,254.19,616C261.53,652.61,308.76,706.12,319.26,716C329.55,725.7,322.26,748.17,339.26,765.17C356.26,782.17,381.26,783,399.26,772C415.26,772,423.65,767.84,427.66,751C398.35,749.25,381.26,721,384.5,707.07Z"
          fill="url(#eRU21YPxKsw58-fill)"
          stroke="none"
          stroke-width="1"
        />
        <path
          id="eRU21YPxKsw59"
          d="M254.19,616C261.53,652.61,308.76,706.12,319.26,716C319.739634,716.455891,320.184226,716.947283,320.59,717.47L320.59,717.47C320.59,717.47,279.34,655.75,269.74,632.18C260.14,608.61,260.74,587.34,285.56,578.28C268.53,575.38,249.05,590.38,254.19,616Z"
          opacity="0.2"
          fill="rgb(60,22,72)"
          stroke="none"
          stroke-width="1"
        />
        <path
          id="eRU21YPxKsw60"
          d="M384.5,707.07L392.61,705.4C391.070079,704.714399,389.362012,704.498717,387.7,704.78C386.360726,705.063836,385.200769,705.893931,384.5,707.07Z"
          fill="rgb(60,22,72)"
          stroke="none"
          stroke-width="1"
        />
        <path
          id="eRU21YPxKsw61"
          d="M399.26,772C399.26,772,362.26,765,357.26,733C353.18,741.92,357.15,753.24,359.44,756.82C365.92,766.97,376.26,772.12,393.26,775.12C395.32828,774.216934,397.332886,773.174538,399.26,772Z"
          opacity="0.3"
          fill="rgb(60,22,72)"
          stroke="none"
          stroke-width="1"
        />
      </g>
      <g id="eRU21YPxKsw62">
        <g
          id="eRU21YPxKsw63_to"
          style="
            offset-path: path(
              'M776.946337,541.394641C787.900491,339.148655,1019.655183,124.356027,1049.977884,72.519334L776.946337,541.394641C787.900491,339.148655,1019.655183,124.356027,1049.977884,72.519334L776.946337,541.394641C787.900491,339.148655,1019.655183,124.356027,1049.977884,72.519334L776.946337,541.394641C787.900491,339.148655,1019.655183,124.356027,1049.977884,72.519334'
            );
            offset-rotate: 0deg;
          "
        >
          <g id="eRU21YPxKsw63_ts" transform="scale(0,0)">
            <path
              id="eRU21YPxKsw63"
              d="M817.172422,356.195296C824.377981,355.594832,833.065728,356.397945,837.995728,356.947945C842.495728,357.427945,857.439176,357.826036,857.439176,357.826036C857.439176,357.826036,849.079583,367.80535,846.569583,370.20535C843.689583,372.96535,837.52055,378.794268,834.86055,381.764268C832.20055,384.734268,827.09,389.38,824.59,392.51C822.09,395.64,814.33,405.05,814.33,405.05C814.33,405.05,827.348119,404.231754,831.708119,404.431754C836.068119,404.631754,844.100973,405.472797,848.370973,405.782797C852.640973,406.092797,862.488725,405.922842,862.488725,405.922842"
              transform="translate(-840.085,-380.942893)"
              fill="none"
              stroke="rgb(100,195,175)"
              stroke-width="11"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
        </g>
        <g
          id="eRU21YPxKsw64_to"
          style="
            offset-path: path(
              'M776.946337,541.394641C851.826078,421.411172,841.094958,180.397707,934.949145,37.151926L776.946337,541.394641C851.826078,421.411172,841.094958,180.397707,934.949145,37.151926L776.946337,541.394641C851.826078,421.411172,841.094958,180.397707,934.949145,37.151926L776.946337,541.394641C851.826078,421.411172,841.094958,180.397707,934.949145,37.151926'
            );
            offset-rotate: 0deg;
          "
        >
          <g id="eRU21YPxKsw64_ts" transform="scale(0,0)">
            <path
              id="eRU21YPxKsw64"
              d="M817.172422,356.195296C824.377981,355.594832,833.065728,356.397945,837.995728,356.947945C842.495728,357.427945,857.439176,357.826036,857.439176,357.826036C857.439176,357.826036,849.079583,367.80535,846.569583,370.20535C843.689583,372.96535,837.52055,378.794268,834.86055,381.764268C832.20055,384.734268,827.09,389.38,824.59,392.51C822.09,395.64,814.33,405.05,814.33,405.05C814.33,405.05,827.348119,404.231754,831.708119,404.431754C836.068119,404.631754,844.100973,405.472797,848.370973,405.782797C852.640973,406.092797,862.488725,405.922842,862.488725,405.922842"
              transform="translate(-840.085,-380.942893)"
              fill="none"
              stroke="rgb(100,195,175)"
              stroke-width="11"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
        </g>
        <g
          id="eRU21YPxKsw65_to"
          style="
            offset-path: path(
              'M934.350545,190.927695C946.758931,167.183351,978.754082,135.013175,1031.942982,102.688302L716.057648,529.985476C829.24855,478.473154,863.99389,192.536094,1031.942982,102.688302L716.057648,529.985476C829.24855,478.473154,863.99389,192.536094,1031.942982,102.688302L716.057648,529.985476C829.24855,478.473154,863.99389,192.536094,1031.942982,102.688302L716.057648,529.985476Q829.24855,478.473154,934.350545,190.927695'
            );
            offset-rotate: 0deg;
          "
        >
          <g id="eRU21YPxKsw65_ts" transform="scale(2.29278,2.29278)">
            <path
              id="eRU21YPxKsw65"
              d="M817.172422,356.195296C824.377981,355.594832,833.065728,356.397945,837.995728,356.947945C842.495728,357.427945,857.439176,357.826036,857.439176,357.826036C857.439176,357.826036,849.079583,367.80535,846.569583,370.20535C843.689583,372.96535,837.52055,378.794268,834.86055,381.764268C832.20055,384.734268,827.09,389.38,824.59,392.51C822.09,395.64,814.33,405.05,814.33,405.05C814.33,405.05,827.348119,404.231754,831.708119,404.431754C836.068119,404.631754,844.100973,405.472797,848.370973,405.782797C852.640973,406.092797,862.488725,405.922842,862.488725,405.922842"
              transform="translate(-840.085,-380.942893)"
              opacity="0.230769"
              fill="none"
              stroke="rgb(100,195,175)"
              stroke-width="11"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
        </g>
      </g>
      <g id="eRU21YPxKsw66_to" transform="translate(653.372144,580.915899)">
        <g id="eRU21YPxKsw66_tr" transform="rotate(0)">
          <g id="eRU21YPxKsw66" transform="translate(-654.385,-572.804561)">
            <g id="eRU21YPxKsw67">
              <path
                id="eRU21YPxKsw68"
                d="M591.26,389C602.17,382.7,660.26,380,733.26,442C765.26,452,796.77,472.12,814.55,503.71C832.33,535.3,828.55,591.12,828.3,594.47C825.44,597.83,817.13,598.38,810.56,600.22C814.22,600.78,827.42,603.42,826.26,606C819.04,622.07,784.26,641,708.43,650.79C644.49,659,622.05,648.33,604.26,628C590.26,612,580.26,568,591.26,508C570.26,449,570.26,403,591.26,389Z"
                fill="url(#eRU21YPxKsw68-fill)"
                stroke="none"
                stroke-width="1"
              />
              <path
                id="eRU21YPxKsw69"
                d="M625.35,567C612.09,575,608.07,562,614.72,553.27C622.5,543,638.61,559,625.35,567ZM616.6,586.11C611.95,592.25,614.76,601.31,624.04,595.72C633.32,590.13,622.05,579,616.6,586.14ZM604.35,592.63C612.67,587.55,605.03,570.97,600.5,570.63C595.97,570.29,600,595.32,604.35,592.66ZM609.35,525.06C604.61,523.5,600.4,530.06,599.81,539.8C599.22,549.54,600.58,549.59,607.3,545.61C614.02,541.63,616.49,527.44,609.31,525.09Z"
                fill="url(#eRU21YPxKsw69-fill)"
                stroke="none"
                stroke-width="1"
              />
              <path
                id="eRU21YPxKsw70"
                d="M591.26,389C570.26,403,570.26,449,591.26,508C591.26,508,599.03,515.83,607.1,513.61C645.39,503.06,733.26,442,733.26,442C660.26,380,602.17,382.7,591.26,389Z"
                fill="url(#eRU21YPxKsw70-fill)"
                stroke="none"
                stroke-width="1"
              />
            </g>
            <path
              id="eRU21YPxKsw71"
              d="M703.26,595.72C728.989661,597.47328,760.458079,597.68816,810.11,596.22L824.34,593.72"
              fill="none"
              stroke="url(#eRU21YPxKsw71-stroke)"
              stroke-width="8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              id="eRU21YPxKsw72"
              d="M815.51,575.59C818.04,573.06,811.72,566.24,807.93,570.03C804.14,573.82,812.1,579,815.51,575.59Z"
              fill="rgb(40,128,143)"
              stroke="none"
              stroke-width="1"
            />
            <g id="eRU21YPxKsw73">
              <g id="eRU21YPxKsw74" opacity="0.2">
                <ellipse
                  id="eRU21YPxKsw75"
                  rx="58.82"
                  ry="56.08"
                  transform="matrix(1 0 0 1 723.2 526.3)"
                  filter="url(#eRU21YPxKsw75-filter)"
                  fill="rgb(60,22,72)"
                  stroke="none"
                  stroke-width="1"
                />
              </g>
              <ellipse
                id="eRU21YPxKsw76"
                rx="53.5"
                ry="51"
                transform="matrix(1 0 0 1 724.76 521)"
                fill="url(#eRU21YPxKsw76-fill)"
                stroke="none"
                stroke-width="1"
              />
              <path
                id="eRU21YPxKsw77"
                d="M763.85,512.78C747.07,516.57,738.41,517.87,717.49,519.28C738.41,513.47,747.07,512.78,763.85,512.78Z"
                fill="none"
                stroke="rgb(60,22,72)"
                stroke-width="8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="eRU21YPxKsw78"
                d="M693.26,487C699.58,483.84,708.26,495,703.26,504C698.26,513,681.26,516,680.26,509C679.26,502,685.26,491,693.26,487ZM718.26,488C720.26,490,730.26,485,730.26,481C730.26,477,727.09,474.7,723.26,477C718.26,480,716.26,486,718.26,488Z"
                opacity="0.5"
                fill="rgb(255,243,196)"
                stroke="none"
                stroke-width="1"
              />
              <path
                id="eRU21YPxKsw79"
                d="M709.85,562.64C706.85,565.64,692.14,554.94,697.22,551.95C704.29,547.78,712.79,559.69,709.85,562.64ZM726.52,562.64C726.52,568.87,747.52,563.32,745.97,559.27C744.42,555.22,726.52,556.41,726.52,562.64ZM756.1,551.25C758.1,553.25,763.53,547.77,761.51,545.76C759.49,543.75,752.42,547.57,756.1,551.25Z"
                opacity="0.1"
                fill="rgb(255,255,255)"
                stroke="none"
                stroke-width="1"
              />
            </g>
          </g>
        </g>
      </g>
      <circle
        id="eRU21YPxKsw80"
        display="none"
        r="27.5"
        transform="matrix(5.824275 0 0 5.824275 519.880799 553.316063)"
        opacity="0"
        filter="url(#eRU21YPxKsw80-filter)"
        fill="rgb(255,160,85)"
        stroke="none"
        stroke-width="1"
      />
      <path
        id="eRU21YPxKsw81"
        display="none"
        d="M670.34,627.59C643.41,627.59,623.45,619.43,616.4,592.7C608.11,561.2,621.67,529.09,615.75,499.28C612.02,480.45,585.03,419.28,611.68,411.93C630.57,406.75,663.61,425.93,678.34,434.55C693.28,443.24,705.68,456.97,720.46,465.24C729.06,470.06,739.88,471.74,748.82,476.44C782.69,494.27,799.03,522.15,802.11,559.53C804.4,587.3,803.56,599.02,777.11,609.1C744.19,621.65,705.41,627.59,670.34,627.59Z"
        opacity="0"
        filter="url(#eRU21YPxKsw81-filter)"
        fill="rgb(1,237,255)"
        stroke="none"
        stroke-width="1"
      />
    </g>
  </svg>
</template>

<style>
#eRU21YPxKsw4_tr {
  animation: eRU21YPxKsw4_tr__tr 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw4_tr__tr {
  0% {
    transform: translate(141.897434px, 772.022303px) rotate(0deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  29.166667% {
    transform: translate(141.897434px, 772.022303px) rotate(3.944877deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  42.5% {
    transform: translate(141.897434px, 772.022303px) rotate(1.919959deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  66.666667% {
    transform: translate(141.897434px, 772.022303px) rotate(8.960516deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  100% {
    transform: translate(141.897434px, 772.022303px) rotate(0deg);
  }
}
#eRU21YPxKsw5_tr {
  animation: eRU21YPxKsw5_tr__tr 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw5_tr__tr {
  0% {
    transform: translate(193.794972px, 651.507014px) rotate(0deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  30.833333% {
    transform: translate(193.794972px, 651.507014px) rotate(6.318609deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  61.666667% {
    transform: translate(193.794972px, 651.507014px) rotate(0deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  81.083333% {
    transform: translate(193.794972px, 651.507014px) rotate(6.442639deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  100% {
    transform: translate(193.794972px, 651.507014px) rotate(0deg);
  }
}
#eRU21YPxKsw9_tr {
  animation: eRU21YPxKsw9_tr__tr 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw9_tr__tr {
  0% {
    transform: translate(190.51079px, 642.81881px) rotate(0deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  29.166667% {
    transform: translate(190.51079px, 642.81881px) rotate(3.944877deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  42.5% {
    transform: translate(190.51079px, 642.81881px) rotate(1.919959deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  66.666667% {
    transform: translate(190.51079px, 642.81881px) rotate(8.960516deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  100% {
    transform: translate(190.51079px, 642.81881px) rotate(0deg);
  }
}
#eRU21YPxKsw12_tr {
  animation: eRU21YPxKsw12_tr__tr 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw12_tr__tr {
  0% {
    transform: translate(192.970695px, 653.486657px) rotate(0deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  30.833333% {
    transform: translate(192.970695px, 653.486657px) rotate(6.318609deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  61.666667% {
    transform: translate(192.970695px, 653.486657px) rotate(0deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  81.083333% {
    transform: translate(192.970695px, 653.486657px) rotate(6.442639deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  100% {
    transform: translate(192.970695px, 653.486657px) rotate(0deg);
  }
}
#eRU21YPxKsw17_ts {
  animation: eRU21YPxKsw17_ts__ts 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw17_ts__ts {
  0% {
    transform: translate(575.51px, 653.326828px) scale(1, 1);
    animation-timing-function: cubic-bezier(0.345, 0.01, 0.26, 0.995);
  }
  10% {
    transform: translate(575.51px, 653.326828px) scale(1.009882, 1.053572);
    animation-timing-function: cubic-bezier(0.055, 0.025, 0.385, 0.985);
  }
  18.333333% {
    transform: translate(575.51px, 653.326828px) scale(1, 1);
    animation-timing-function: cubic-bezier(0.42, 0, 0.005, 1);
  }
  25% {
    transform: translate(575.51px, 653.326828px) scale(1, 1);
    animation-timing-function: cubic-bezier(0.345, 0.01, 0.26, 0.995);
  }
  35% {
    transform: translate(575.51px, 653.326828px) scale(1.009882, 1.053572);
    animation-timing-function: cubic-bezier(0.055, 0.025, 0.385, 0.985);
  }
  43.333333% {
    transform: translate(575.51px, 653.326828px) scale(1, 1);
    animation-timing-function: cubic-bezier(0.42, 0, 0.005, 1);
  }
  50% {
    transform: translate(575.51px, 653.326828px) scale(1, 1);
    animation-timing-function: cubic-bezier(0.345, 0.01, 0.26, 0.995);
  }
  60% {
    transform: translate(575.51px, 653.326828px) scale(1.009882, 1.053572);
    animation-timing-function: cubic-bezier(0.055, 0.025, 0.385, 0.985);
  }
  68.333333% {
    transform: translate(575.51px, 653.326828px) scale(1, 1);
    animation-timing-function: cubic-bezier(0.42, 0, 0.005, 1);
  }
  75% {
    transform: translate(575.51px, 653.326828px) scale(1, 1);
    animation-timing-function: cubic-bezier(0.345, 0.01, 0.26, 0.995);
  }
  85% {
    transform: translate(575.51px, 653.326828px) scale(1.009882, 1.053572);
    animation-timing-function: cubic-bezier(0.055, 0.025, 0.385, 0.985);
  }
  93.333333% {
    transform: translate(575.51px, 653.326828px) scale(1, 1);
  }
  100% {
    transform: translate(575.51px, 653.326828px) scale(1, 1);
  }
}
#eRU21YPxKsw19-fill-0 {
  animation: eRU21YPxKsw19-fill-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw19-fill-0__c {
  0% {
    stop-color: rgb(52, 165, 148);
  }
  10% {
    stop-color: rgb(52, 67, 148);
  }
  25% {
    stop-color: rgb(52, 67, 148);
  }
  35% {
    stop-color: rgb(214, 0, 93);
  }
  50% {
    stop-color: rgb(214, 0, 93);
  }
  60% {
    stop-color: rgb(255, 141, 54);
  }
  75% {
    stop-color: rgb(255, 141, 54);
  }
  85% {
    stop-color: rgb(52, 165, 148);
  }
  100% {
    stop-color: rgb(52, 165, 148);
  }
}
#eRU21YPxKsw19-fill-1 {
  animation: eRU21YPxKsw19-fill-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw19-fill-1__c {
  0% {
    stop-color: rgb(16, 77, 134);
  }
  10% {
    stop-color: rgb(130, 39, 133);
  }
  25% {
    stop-color: rgb(130, 39, 133);
  }
  35% {
    stop-color: rgb(237, 152, 116);
  }
  50% {
    stop-color: rgb(237, 152, 116);
  }
  60% {
    stop-color: rgb(178, 32, 147);
  }
  75% {
    stop-color: rgb(178, 32, 147);
  }
  85% {
    stop-color: rgb(16, 77, 134);
  }
  100% {
    stop-color: rgb(16, 77, 134);
  }
}
#eRU21YPxKsw19-fill-2 {
  animation: eRU21YPxKsw19-fill-2__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw19-fill-2__c {
  0% {
    stop-color: rgb(40, 128, 143);
  }
  10% {
    stop-color: rgb(38, 36, 125);
  }
  25% {
    stop-color: rgb(38, 36, 125);
  }
  35% {
    stop-color: rgb(163, 0, 87);
  }
  50% {
    stop-color: rgb(163, 0, 87);
  }
  60% {
    stop-color: rgb(252, 104, 102);
  }
  75% {
    stop-color: rgb(252, 104, 102);
  }
  85% {
    stop-color: rgb(40, 128, 143);
  }
  100% {
    stop-color: rgb(40, 128, 143);
  }
}
#eRU21YPxKsw20-fill-0 {
  animation: eRU21YPxKsw20-fill-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw20-fill-0__c {
  0% {
    stop-color: rgb(232, 61, 93);
  }
  10% {
    stop-color: rgb(160, 29, 125);
  }
  25% {
    stop-color: rgb(160, 29, 125);
  }
  35% {
    stop-color: rgb(0, 120, 153);
  }
  50% {
    stop-color: rgb(0, 120, 153);
  }
  60% {
    stop-color: rgb(33, 0, 153);
  }
  75% {
    stop-color: rgb(33, 0, 153);
  }
  85% {
    stop-color: rgb(232, 61, 93);
  }
  100% {
    stop-color: rgb(232, 61, 93);
  }
}
#eRU21YPxKsw20-fill-1 {
  animation: eRU21YPxKsw20-fill-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw20-fill-1__c {
  0% {
    stop-color: rgb(236, 143, 101);
  }
  10% {
    stop-color: rgb(206, 86, 123);
  }
  25% {
    stop-color: rgb(206, 86, 123);
  }
  35% {
    stop-color: rgb(163, 227, 145);
  }
  50% {
    stop-color: rgb(163, 227, 145);
  }
  60% {
    stop-color: rgb(109, 210, 247);
  }
  75% {
    stop-color: rgb(109, 210, 247);
  }
  85% {
    stop-color: rgb(236, 143, 101);
  }
  100% {
    stop-color: rgb(236, 143, 101);
  }
}
#eRU21YPxKsw23-fill-0 {
  animation: eRU21YPxKsw23-fill-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw23-fill-0__c {
  0% {
    stop-color: rgb(16, 77, 134);
  }
  10% {
    stop-color: rgb(122, 37, 125);
  }
  25% {
    stop-color: rgb(122, 37, 125);
  }
  35% {
    stop-color: rgb(237, 152, 116);
  }
  50% {
    stop-color: rgb(237, 152, 116);
  }
  60% {
    stop-color: rgb(178, 32, 147);
  }
  75% {
    stop-color: rgb(178, 32, 147);
  }
  85% {
    stop-color: rgb(16, 77, 134);
  }
  100% {
    stop-color: rgb(16, 77, 134);
  }
}
#eRU21YPxKsw23-fill-1 {
  animation: eRU21YPxKsw23-fill-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw23-fill-1__c {
  0% {
    stop-color: rgb(52, 165, 148);
  }
  10% {
    stop-color: rgb(52, 67, 148);
  }
  25% {
    stop-color: rgb(52, 67, 148);
  }
  35% {
    stop-color: rgb(214, 0, 93);
  }
  50% {
    stop-color: rgb(214, 0, 93);
  }
  60% {
    stop-color: rgb(255, 141, 54);
  }
  75% {
    stop-color: rgb(255, 141, 54);
  }
  85% {
    stop-color: rgb(52, 165, 148);
  }
  100% {
    stop-color: rgb(52, 165, 148);
  }
}
#eRU21YPxKsw24-fill-0 {
  animation: eRU21YPxKsw24-fill-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw24-fill-0__c {
  0% {
    stop-color: rgb(52, 165, 148);
  }
  10% {
    stop-color: rgb(52, 67, 148);
  }
  25% {
    stop-color: rgb(52, 67, 148);
  }
  35% {
    stop-color: rgb(214, 0, 93);
  }
  50% {
    stop-color: rgb(214, 0, 93);
  }
  60% {
    stop-color: rgb(255, 141, 54);
  }
  75% {
    stop-color: rgb(255, 141, 54);
  }
  85% {
    stop-color: rgb(52, 165, 148);
  }
  100% {
    stop-color: rgb(52, 165, 148);
  }
}
#eRU21YPxKsw24-fill-1 {
  animation: eRU21YPxKsw24-fill-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw24-fill-1__c {
  0% {
    stop-color: rgb(157, 209, 129);
  }
  10% {
    stop-color: rgb(74, 185, 194);
  }
  25% {
    stop-color: rgb(74, 185, 194);
  }
  35% {
    stop-color: rgb(255, 164, 122);
  }
  50% {
    stop-color: rgb(255, 164, 122);
  }
  60% {
    stop-color: rgb(255, 234, 148);
  }
  75% {
    stop-color: rgb(255, 234, 148);
  }
  85% {
    stop-color: rgb(157, 209, 129);
  }
  100% {
    stop-color: rgb(157, 209, 129);
  }
}
#eRU21YPxKsw28-fill-0 {
  animation: eRU21YPxKsw28-fill-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw28-fill-0__c {
  0% {
    stop-color: rgb(52, 165, 148);
  }
  10% {
    stop-color: rgb(52, 67, 148);
  }
  25% {
    stop-color: rgb(52, 67, 148);
  }
  35% {
    stop-color: rgb(214, 0, 93);
  }
  50% {
    stop-color: rgb(214, 0, 93);
  }
  60% {
    stop-color: rgb(255, 141, 54);
  }
  75% {
    stop-color: rgb(255, 141, 54);
  }
  85% {
    stop-color: rgb(52, 165, 148);
  }
  100% {
    stop-color: rgb(52, 165, 148);
  }
}
#eRU21YPxKsw28-fill-1 {
  animation: eRU21YPxKsw28-fill-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw28-fill-1__c {
  0% {
    stop-color: rgb(157, 209, 129);
  }
  10% {
    stop-color: rgb(69, 173, 182);
  }
  25% {
    stop-color: rgb(69, 173, 182);
  }
  35% {
    stop-color: rgb(255, 164, 122);
  }
  50% {
    stop-color: rgb(255, 164, 122);
  }
  60% {
    stop-color: rgb(255, 234, 148);
  }
  75% {
    stop-color: rgb(255, 234, 148);
  }
  85% {
    stop-color: rgb(157, 209, 129);
  }
  100% {
    stop-color: rgb(157, 209, 129);
  }
}
#eRU21YPxKsw30-fill-0 {
  animation: eRU21YPxKsw30-fill-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw30-fill-0__c {
  0% {
    stop-color: rgb(16, 77, 134);
  }
  10% {
    stop-color: rgb(130, 39, 133);
  }
  25% {
    stop-color: rgb(130, 39, 133);
  }
  35% {
    stop-color: rgb(237, 152, 116);
  }
  50% {
    stop-color: rgb(237, 152, 116);
  }
  60% {
    stop-color: rgb(178, 32, 147);
  }
  75% {
    stop-color: rgb(178, 32, 147);
  }
  85% {
    stop-color: rgb(16, 77, 134);
  }
  100% {
    stop-color: rgb(16, 77, 134);
  }
}
#eRU21YPxKsw30-fill-1 {
  animation: eRU21YPxKsw30-fill-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw30-fill-1__c {
  0% {
    stop-color: rgb(232, 61, 93);
  }
  10% {
    stop-color: rgb(160, 29, 125);
  }
  25% {
    stop-color: rgb(160, 29, 125);
  }
  35% {
    stop-color: rgb(0, 120, 153);
  }
  50% {
    stop-color: rgb(0, 120, 153);
  }
  60% {
    stop-color: rgb(33, 0, 153);
  }
  75% {
    stop-color: rgb(33, 0, 153);
  }
  85% {
    stop-color: rgb(232, 61, 93);
  }
  100% {
    stop-color: rgb(232, 61, 93);
  }
}
#eRU21YPxKsw30-fill-2 {
  animation: eRU21YPxKsw30-fill-2__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw30-fill-2__c {
  0% {
    stop-color: rgb(236, 143, 101);
  }
  10% {
    stop-color: rgb(206, 86, 123);
  }
  25% {
    stop-color: rgb(206, 86, 123);
  }
  35% {
    stop-color: rgb(163, 227, 145);
  }
  50% {
    stop-color: rgb(163, 227, 145);
  }
  60% {
    stop-color: rgb(109, 210, 247);
  }
  75% {
    stop-color: rgb(109, 210, 247);
  }
  85% {
    stop-color: rgb(236, 143, 101);
  }
  100% {
    stop-color: rgb(236, 143, 101);
  }
}
#eRU21YPxKsw31-fill-0 {
  animation: eRU21YPxKsw31-fill-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw31-fill-0__c {
  0% {
    stop-color: rgb(74, 197, 119);
  }
  10% {
    stop-color: rgb(48, 147, 189);
  }
  25% {
    stop-color: rgb(48, 147, 189);
  }
  35% {
    stop-color: rgb(255, 60, 85);
  }
  50% {
    stop-color: rgb(255, 60, 85);
  }
  60% {
    stop-color: rgb(252, 104, 102);
  }
  75% {
    stop-color: rgb(252, 104, 102);
  }
  85% {
    stop-color: rgb(74, 197, 119);
  }
  100% {
    stop-color: rgb(74, 197, 119);
  }
}
#eRU21YPxKsw31-fill-1 {
  animation: eRU21YPxKsw31-fill-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw31-fill-1__c {
  0% {
    stop-color: rgb(40, 128, 143);
  }
  10% {
    stop-color: rgb(38, 36, 125);
  }
  25% {
    stop-color: rgb(38, 36, 125);
  }
  35% {
    stop-color: rgb(163, 0, 87);
  }
  50% {
    stop-color: rgb(163, 0, 87);
  }
  60% {
    stop-color: rgb(209, 65, 77);
  }
  75% {
    stop-color: rgb(209, 65, 77);
  }
  85% {
    stop-color: rgb(40, 128, 143);
  }
  100% {
    stop-color: rgb(40, 128, 143);
  }
}
#eRU21YPxKsw31-fill-2 {
  animation: eRU21YPxKsw31-fill-2__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw31-fill-2__c {
  0% {
    stop-color: rgb(30, 69, 120);
  }
  10% {
    stop-color: rgb(173, 39, 133);
  }
  25% {
    stop-color: rgb(173, 39, 133);
  }
  35% {
    stop-color: rgb(255, 214, 148);
  }
  50% {
    stop-color: rgb(255, 214, 148);
  }
  60% {
    stop-color: rgb(178, 32, 147);
  }
  75% {
    stop-color: rgb(178, 32, 147);
  }
  85% {
    stop-color: rgb(30, 69, 120);
  }
  100% {
    stop-color: rgb(30, 69, 120);
  }
}
#eRU21YPxKsw33 {
  animation-name: eRU21YPxKsw33_c_o, eRU21YPxKsw33_f_p;
  animation-duration: 12000ms;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
  animation-direction: normal;
  animation-iteration-count: infinite;
}
@keyframes eRU21YPxKsw33_c_o {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 0.3;
  }
  18.333333% {
    opacity: 0;
  }
  25% {
    opacity: 0;
  }
  35% {
    opacity: 0.3;
  }
  43.333333% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  60% {
    opacity: 0.3;
  }
  68.333333% {
    opacity: 0;
  }
  75% {
    opacity: 0;
  }
  85% {
    opacity: 0.3;
  }
  93.333333% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
@keyframes eRU21YPxKsw33_f_p {
  0% {
    fill: rgb(1, 237, 255);
    animation-timing-function: step-end;
  }
  25% {
    fill: rgb(255, 170, 55);
  }
  75% {
    fill: rgb(248, 255, 85);
  }
  100% {
    fill: rgb(248, 255, 85);
  }
}
#eRU21YPxKsw38_tr {
  animation: eRU21YPxKsw38_tr__tr 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw38_tr__tr {
  0% {
    transform: translate(777.682246px, 676.750734px) rotate(0deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  29.166667% {
    transform: translate(777.682246px, 676.750734px) rotate(-3.94deg);
  }
  42.5% {
    transform: translate(777.682246px, 676.750734px) rotate(-1.92deg);
  }
  66.666667% {
    transform: translate(777.682246px, 676.750734px) rotate(-8.96deg);
  }
  100% {
    transform: translate(777.682246px, 676.750734px) rotate(0deg);
  }
}
#eRU21YPxKsw39_tr {
  animation: eRU21YPxKsw39_tr__tr 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw39_tr__tr {
  0% {
    transform: translate(840.024166px, 691.329757px) rotate(-1.728843deg);
  }
  6.666667% {
    transform: translate(840.024166px, 691.329757px) rotate(0deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  31.666667% {
    transform: translate(840.024166px, 691.329757px) rotate(-6.67532deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  56.666667% {
    transform: translate(840.024166px, 691.329757px) rotate(2.863451deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  81.666667% {
    transform: translate(840.024166px, 691.329757px) rotate(-11.727406deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  100% {
    transform: translate(840.024166px, 691.329757px) rotate(-1.728843deg);
  }
}
#eRU21YPxKsw44_tr {
  animation: eRU21YPxKsw44_tr__tr 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw44_tr__tr {
  0% {
    transform: translate(824.840516px, 700.763208px) rotate(0deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  25% {
    transform: translate(824.840516px, 700.763208px) rotate(-6.67532deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  50% {
    transform: translate(824.840516px, 700.763208px) rotate(2.863451deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  75% {
    transform: translate(824.840516px, 700.763208px) rotate(-11.727406deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  100% {
    transform: translate(824.840516px, 700.763208px) rotate(0deg);
  }
}
#eRU21YPxKsw50-fill-0 {
  animation: eRU21YPxKsw50-fill-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw50-fill-0__c {
  0% {
    stop-color: rgb(52, 165, 148);
  }
  10% {
    stop-color: rgb(52, 67, 148);
  }
  25% {
    stop-color: rgb(52, 67, 148);
  }
  35% {
    stop-color: rgb(214, 0, 93);
  }
  50% {
    stop-color: rgb(214, 0, 93);
  }
  60% {
    stop-color: rgb(255, 141, 54);
  }
  75% {
    stop-color: rgb(255, 141, 54);
  }
  85% {
    stop-color: rgb(52, 165, 148);
  }
  100% {
    stop-color: rgb(52, 165, 148);
  }
}
#eRU21YPxKsw50-fill-1 {
  animation: eRU21YPxKsw50-fill-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw50-fill-1__c {
  0% {
    stop-color: rgb(157, 209, 129);
  }
  10% {
    stop-color: rgb(74, 185, 194);
  }
  25% {
    stop-color: rgb(74, 185, 194);
  }
  35% {
    stop-color: rgb(255, 164, 122);
  }
  50% {
    stop-color: rgb(255, 164, 122);
  }
  60% {
    stop-color: rgb(255, 234, 148);
  }
  75% {
    stop-color: rgb(255, 234, 148);
  }
  85% {
    stop-color: rgb(157, 209, 129);
  }
  100% {
    stop-color: rgb(157, 209, 129);
  }
}
#eRU21YPxKsw51-fill-0 {
  animation: eRU21YPxKsw51-fill-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw51-fill-0__c {
  0% {
    stop-color: rgb(40, 128, 143);
  }
  10% {
    stop-color: rgb(38, 36, 125);
  }
  25% {
    stop-color: rgb(38, 36, 125);
  }
  35% {
    stop-color: rgb(163, 0, 87);
  }
  50% {
    stop-color: rgb(163, 0, 87);
  }
  60% {
    stop-color: rgb(252, 104, 102);
  }
  75% {
    stop-color: rgb(252, 104, 102);
  }
  85% {
    stop-color: rgb(40, 128, 143);
  }
  100% {
    stop-color: rgb(40, 128, 143);
  }
}
#eRU21YPxKsw51-fill-1 {
  animation: eRU21YPxKsw51-fill-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw51-fill-1__c {
  0% {
    stop-color: rgb(52, 165, 148);
  }
  10% {
    stop-color: rgb(52, 67, 148);
  }
  25% {
    stop-color: rgb(52, 67, 148);
  }
  35% {
    stop-color: rgb(214, 0, 93);
  }
  50% {
    stop-color: rgb(214, 0, 93);
  }
  60% {
    stop-color: rgb(255, 141, 54);
  }
  75% {
    stop-color: rgb(255, 141, 54);
  }
  85% {
    stop-color: rgb(52, 165, 148);
  }
  100% {
    stop-color: rgb(52, 165, 148);
  }
}
#eRU21YPxKsw52-fill-0 {
  animation: eRU21YPxKsw52-fill-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw52-fill-0__c {
  0% {
    stop-color: rgb(52, 165, 148);
  }
  10% {
    stop-color: rgb(52, 67, 148);
  }
  25% {
    stop-color: rgb(52, 67, 148);
  }
  35% {
    stop-color: rgb(214, 0, 93);
  }
  50% {
    stop-color: rgb(214, 0, 93);
  }
  60% {
    stop-color: rgb(255, 141, 54);
  }
  75% {
    stop-color: rgb(255, 141, 54);
  }
  85% {
    stop-color: rgb(52, 165, 148);
  }
  100% {
    stop-color: rgb(52, 165, 148);
  }
}
#eRU21YPxKsw52-fill-1 {
  animation: eRU21YPxKsw52-fill-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw52-fill-1__c {
  0% {
    stop-color: rgb(157, 209, 129);
  }
  10% {
    stop-color: rgb(74, 185, 194);
  }
  25% {
    stop-color: rgb(74, 185, 194);
  }
  35% {
    stop-color: rgb(255, 164, 122);
  }
  50% {
    stop-color: rgb(255, 164, 122);
  }
  60% {
    stop-color: rgb(255, 234, 148);
  }
  75% {
    stop-color: rgb(255, 234, 148);
  }
  85% {
    stop-color: rgb(157, 209, 129);
  }
  100% {
    stop-color: rgb(157, 209, 129);
  }
}
#eRU21YPxKsw56-fill-0 {
  animation: eRU21YPxKsw56-fill-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw56-fill-0__c {
  0% {
    stop-color: rgb(52, 165, 148);
  }
  10% {
    stop-color: rgb(52, 67, 148);
  }
  25% {
    stop-color: rgb(52, 67, 148);
  }
  35% {
    stop-color: rgb(214, 0, 93);
  }
  50% {
    stop-color: rgb(214, 0, 93);
  }
  60% {
    stop-color: rgb(255, 141, 54);
  }
  75% {
    stop-color: rgb(255, 141, 54);
  }
  85% {
    stop-color: rgb(52, 165, 148);
  }
  100% {
    stop-color: rgb(52, 165, 148);
  }
}
#eRU21YPxKsw56-fill-1 {
  animation: eRU21YPxKsw56-fill-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw56-fill-1__c {
  0% {
    stop-color: rgb(157, 209, 129);
  }
  10% {
    stop-color: rgb(74, 185, 194);
  }
  25% {
    stop-color: rgb(74, 185, 194);
  }
  35% {
    stop-color: rgb(255, 164, 122);
  }
  50% {
    stop-color: rgb(255, 164, 122);
  }
  60% {
    stop-color: rgb(255, 234, 148);
  }
  75% {
    stop-color: rgb(255, 234, 148);
  }
  85% {
    stop-color: rgb(157, 209, 129);
  }
  100% {
    stop-color: rgb(157, 209, 129);
  }
}
#eRU21YPxKsw57-fill-0 {
  animation: eRU21YPxKsw57-fill-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw57-fill-0__c {
  0% {
    stop-color: rgb(40, 128, 143);
  }
  10% {
    stop-color: rgb(38, 36, 125);
  }
  25% {
    stop-color: rgb(38, 36, 125);
  }
  35% {
    stop-color: rgb(163, 0, 87);
  }
  50% {
    stop-color: rgb(163, 0, 87);
  }
  60% {
    stop-color: rgb(252, 104, 102);
  }
  75% {
    stop-color: rgb(252, 104, 102);
  }
  85% {
    stop-color: rgb(40, 128, 143);
  }
  100% {
    stop-color: rgb(40, 128, 143);
  }
}
#eRU21YPxKsw57-fill-1 {
  animation: eRU21YPxKsw57-fill-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw57-fill-1__c {
  0% {
    stop-color: rgb(52, 165, 148);
  }
  10% {
    stop-color: rgb(52, 67, 148);
  }
  25% {
    stop-color: rgb(52, 67, 148);
  }
  35% {
    stop-color: rgb(214, 0, 93);
  }
  50% {
    stop-color: rgb(214, 0, 93);
  }
  60% {
    stop-color: rgb(255, 141, 54);
  }
  75% {
    stop-color: rgb(255, 141, 54);
  }
  85% {
    stop-color: rgb(52, 165, 148);
  }
  100% {
    stop-color: rgb(52, 165, 148);
  }
}
#eRU21YPxKsw58-fill-0 {
  animation: eRU21YPxKsw58-fill-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw58-fill-0__c {
  0% {
    stop-color: rgb(52, 165, 148);
  }
  10% {
    stop-color: rgb(52, 67, 148);
  }
  25% {
    stop-color: rgb(52, 67, 148);
  }
  35% {
    stop-color: rgb(214, 0, 93);
  }
  50% {
    stop-color: rgb(214, 0, 93);
  }
  60% {
    stop-color: rgb(255, 141, 54);
  }
  75% {
    stop-color: rgb(255, 141, 54);
  }
  85% {
    stop-color: rgb(52, 165, 148);
  }
  100% {
    stop-color: rgb(52, 165, 148);
  }
}
#eRU21YPxKsw58-fill-1 {
  animation: eRU21YPxKsw58-fill-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw58-fill-1__c {
  0% {
    stop-color: rgb(157, 209, 129);
  }
  10% {
    stop-color: rgb(74, 185, 194);
  }
  25% {
    stop-color: rgb(74, 185, 194);
  }
  35% {
    stop-color: rgb(255, 164, 122);
  }
  50% {
    stop-color: rgb(255, 164, 122);
  }
  60% {
    stop-color: rgb(255, 234, 148);
  }
  75% {
    stop-color: rgb(255, 234, 148);
  }
  85% {
    stop-color: rgb(157, 209, 129);
  }
  100% {
    stop-color: rgb(157, 209, 129);
  }
}
#eRU21YPxKsw63_to {
  animation: eRU21YPxKsw63_to__to 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw63_to__to {
  0% {
    offset-distance: 0%;
  }
  21.666667% {
    offset-distance: 14.385773%;
    animation-timing-function: step-end;
  }
  25% {
    offset-distance: 28.538076%;
  }
  46.666667% {
    offset-distance: 42.923849%;
    animation-timing-function: step-end;
  }
  50% {
    offset-distance: 57.076151%;
  }
  71.666667% {
    offset-distance: 71.461924%;
    animation-timing-function: step-end;
  }
  75% {
    offset-distance: 85.614227%;
  }
  96.666667% {
    offset-distance: 100%;
  }
  100% {
    offset-distance: 100%;
  }
}
#eRU21YPxKsw63_ts {
  animation: eRU21YPxKsw63_ts__ts 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw63_ts__ts {
  0% {
    transform: scale(0, 0);
  }
  21.666667% {
    transform: scale(2.980614, 2.980614);
    animation-timing-function: step-end;
  }
  25% {
    transform: scale(0, 0);
  }
  46.666667% {
    transform: scale(2.980614, 2.980614);
    animation-timing-function: step-end;
  }
  50% {
    transform: scale(0, 0);
  }
  71.666667% {
    transform: scale(2.980614, 2.980614);
    animation-timing-function: step-end;
  }
  75% {
    transform: scale(0, 0);
  }
  96.666667% {
    transform: scale(2.980614, 2.980614);
  }
  100% {
    transform: scale(2.980614, 2.980614);
  }
}
#eRU21YPxKsw63 {
  animation-name: eRU21YPxKsw63_c_o, eRU21YPxKsw63_s_p;
  animation-duration: 12000ms;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
  animation-direction: normal;
  animation-iteration-count: infinite;
}
@keyframes eRU21YPxKsw63_c_o {
  0% {
    opacity: 1;
  }
  21.666667% {
    opacity: 0;
    animation-timing-function: step-end;
  }
  25% {
    opacity: 1;
  }
  46.666667% {
    opacity: 0;
    animation-timing-function: step-end;
  }
  50% {
    opacity: 1;
  }
  71.666667% {
    opacity: 0;
    animation-timing-function: step-end;
  }
  75% {
    opacity: 1;
  }
  96.666667% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
@keyframes eRU21YPxKsw63_s_p {
  0% {
    stroke: rgb(100, 195, 175);
  }
  5.833333% {
    stroke: rgb(100, 195, 175);
  }
  12.5% {
    stroke: rgb(21, 140, 220);
  }
  30.833333% {
    stroke: rgb(21, 140, 220);
  }
  37.5% {
    stroke: rgb(255, 49, 93);
  }
  55.833333% {
    stroke: rgb(255, 49, 93);
  }
  62.5% {
    stroke: rgb(255, 181, 56);
  }
  80.833333% {
    stroke: rgb(255, 181, 56);
  }
  87.5% {
    stroke: rgb(100, 195, 175);
  }
  100% {
    stroke: rgb(100, 195, 175);
  }
}
#eRU21YPxKsw64_to {
  animation: eRU21YPxKsw64_to__to 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw64_to__to {
  0% {
    offset-distance: 0%;
  }
  3.333333% {
    offset-distance: 0%;
  }
  25% {
    offset-distance: 14.321087%;
    animation-timing-function: step-end;
  }
  29.166667% {
    offset-distance: 28.559638%;
  }
  50.833333% {
    offset-distance: 42.880724%;
    animation-timing-function: step-end;
  }
  53.333333% {
    offset-distance: 57.119276%;
  }
  75% {
    offset-distance: 71.440362%;
    animation-timing-function: step-end;
  }
  78.333333% {
    offset-distance: 85.678913%;
  }
  100% {
    offset-distance: 100%;
  }
}
#eRU21YPxKsw64_ts {
  animation: eRU21YPxKsw64_ts__ts 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw64_ts__ts {
  0% {
    transform: scale(0, 0);
  }
  3.333333% {
    transform: scale(0, 0);
  }
  25% {
    transform: scale(2.980614, 2.980614);
    animation-timing-function: step-end;
  }
  29.166667% {
    transform: scale(0, 0);
  }
  50.833333% {
    transform: scale(2.980614, 2.980614);
    animation-timing-function: step-end;
  }
  53.333333% {
    transform: scale(0, 0);
  }
  75% {
    transform: scale(2.980614, 2.980614);
    animation-timing-function: step-end;
  }
  78.333333% {
    transform: scale(0, 0);
  }
  100% {
    transform: scale(2.980614, 2.980614);
  }
}
#eRU21YPxKsw64 {
  animation-name: eRU21YPxKsw64_c_o, eRU21YPxKsw64_s_p;
  animation-duration: 12000ms;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
  animation-direction: normal;
  animation-iteration-count: infinite;
}
@keyframes eRU21YPxKsw64_c_o {
  0% {
    opacity: 1;
  }
  3.333333% {
    opacity: 1;
  }
  25% {
    opacity: 0;
    animation-timing-function: step-end;
  }
  29.166667% {
    opacity: 1;
  }
  50.833333% {
    opacity: 0;
    animation-timing-function: step-end;
  }
  53.333333% {
    opacity: 1;
  }
  75% {
    opacity: 0;
    animation-timing-function: step-end;
  }
  78.333333% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes eRU21YPxKsw64_s_p {
  0% {
    stroke: rgb(100, 195, 175);
  }
  5.833333% {
    stroke: rgb(100, 195, 175);
  }
  12.5% {
    stroke: rgb(21, 140, 220);
  }
  30.833333% {
    stroke: rgb(21, 140, 220);
  }
  37.5% {
    stroke: rgb(255, 49, 93);
  }
  55.833333% {
    stroke: rgb(255, 49, 93);
  }
  62.5% {
    stroke: rgb(255, 181, 56);
  }
  80.833333% {
    stroke: rgb(255, 181, 56);
  }
  87.5% {
    stroke: rgb(100, 195, 175);
  }
  100% {
    stroke: rgb(100, 195, 175);
  }
}
#eRU21YPxKsw65_to {
  animation: eRU21YPxKsw65_to__to 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw65_to__to {
  0% {
    offset-distance: 0%;
  }
  5% {
    offset-distance: 3.097063%;
    animation-timing-function: step-end;
  }
  8.333333% {
    offset-distance: 15.478448%;
  }
  30% {
    offset-distance: 28.073405%;
    animation-timing-function: step-end;
  }
  33.333333% {
    offset-distance: 40.45479%;
  }
  55% {
    offset-distance: 53.049747%;
    animation-timing-function: step-end;
  }
  58.333333% {
    offset-distance: 65.431132%;
  }
  80% {
    offset-distance: 78.02609%;
    animation-timing-function: step-end;
  }
  83.333333% {
    offset-distance: 90.407475%;
  }
  100% {
    offset-distance: 100%;
  }
}
#eRU21YPxKsw65_ts {
  animation: eRU21YPxKsw65_ts__ts 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw65_ts__ts {
  0% {
    transform: scale(2.29278, 2.29278);
  }
  5% {
    transform: scale(2.980614, 2.980614);
    animation-timing-function: step-end;
  }
  8.333333% {
    transform: scale(0, 0);
  }
  30% {
    transform: scale(2.980614, 2.980614);
    animation-timing-function: step-end;
  }
  33.333333% {
    transform: scale(0, 0);
  }
  55% {
    transform: scale(2.980614, 2.980614);
    animation-timing-function: step-end;
  }
  58.333333% {
    transform: scale(0, 0);
  }
  80% {
    transform: scale(2.980614, 2.980614);
    animation-timing-function: step-end;
  }
  83.333333% {
    transform: scale(0, 0);
  }
  100% {
    transform: scale(2.29278, 2.29278);
  }
}
#eRU21YPxKsw65 {
  animation-name: eRU21YPxKsw65_c_o, eRU21YPxKsw65_s_p;
  animation-duration: 12000ms;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
  animation-direction: normal;
  animation-iteration-count: infinite;
}
@keyframes eRU21YPxKsw65_c_o {
  0% {
    opacity: 0.230769;
  }
  5% {
    opacity: 0;
    animation-timing-function: step-end;
  }
  8.333333% {
    opacity: 1;
  }
  30% {
    opacity: 0;
    animation-timing-function: step-end;
  }
  33.333333% {
    opacity: 1;
  }
  55% {
    opacity: 0;
    animation-timing-function: step-end;
  }
  58.333333% {
    opacity: 1;
  }
  80% {
    opacity: 0;
    animation-timing-function: step-end;
  }
  83.333333% {
    opacity: 1;
  }
  100% {
    opacity: 0.230769;
  }
}
@keyframes eRU21YPxKsw65_s_p {
  0% {
    stroke: rgb(100, 195, 175);
  }
  5.833333% {
    stroke: rgb(100, 195, 175);
  }
  12.5% {
    stroke: rgb(21, 140, 220);
  }
  30.833333% {
    stroke: rgb(21, 140, 220);
  }
  37.5% {
    stroke: rgb(255, 49, 93);
  }
  55.833333% {
    stroke: rgb(255, 49, 93);
  }
  62.5% {
    stroke: rgb(255, 181, 56);
  }
  80.833333% {
    stroke: rgb(255, 181, 56);
  }
  87.5% {
    stroke: rgb(100, 195, 175);
  }
  100% {
    stroke: rgb(100, 195, 175);
  }
}
#eRU21YPxKsw66_to {
  animation: eRU21YPxKsw66_to__to 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw66_to__to {
  0% {
    transform: translate(653.372144px, 580.915899px);
    animation-timing-function: cubic-bezier(0.345, 0.01, 0.26, 0.995);
  }
  10% {
    transform: translate(654.385px, 572.804561px);
    animation-timing-function: cubic-bezier(0.055, 0.025, 0.385, 0.985);
  }
  18.333333% {
    transform: translate(653.372144px, 580.915899px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.005, 1);
  }
  25% {
    transform: translate(653.372144px, 580.915899px);
    animation-timing-function: cubic-bezier(0.345, 0.01, 0.26, 0.995);
  }
  35% {
    transform: translate(654.385px, 572.804561px);
    animation-timing-function: cubic-bezier(0.055, 0.025, 0.385, 0.985);
  }
  43.333333% {
    transform: translate(653.372144px, 580.915899px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.005, 1);
  }
  50% {
    transform: translate(653.372144px, 580.915899px);
    animation-timing-function: cubic-bezier(0.345, 0.01, 0.26, 0.995);
  }
  60% {
    transform: translate(654.385px, 572.804561px);
    animation-timing-function: cubic-bezier(0.055, 0.025, 0.385, 0.985);
  }
  68.333333% {
    transform: translate(653.372144px, 580.915899px);
    animation-timing-function: cubic-bezier(0.42, 0, 0.005, 1);
  }
  75% {
    transform: translate(653.372144px, 580.915899px);
    animation-timing-function: cubic-bezier(0.345, 0.01, 0.26, 0.995);
  }
  85% {
    transform: translate(654.385px, 572.804561px);
    animation-timing-function: cubic-bezier(0.055, 0.025, 0.385, 0.985);
  }
  93.333333% {
    transform: translate(653.372144px, 580.915899px);
  }
  100% {
    transform: translate(653.372144px, 580.915899px);
  }
}
#eRU21YPxKsw66_tr {
  animation: eRU21YPxKsw66_tr__tr 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw66_tr__tr {
  0% {
    transform: rotate(0deg);
    animation-timing-function: cubic-bezier(0.345, 0.01, 0.26, 0.995);
  }
  10% {
    transform: rotate(1.295493deg);
    animation-timing-function: cubic-bezier(0.055, 0.025, 0.385, 0.985);
  }
  18.333333% {
    transform: rotate(0deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.005, 1);
  }
  25% {
    transform: rotate(0deg);
    animation-timing-function: cubic-bezier(0.345, 0.01, 0.26, 0.995);
  }
  35% {
    transform: rotate(1.295493deg);
    animation-timing-function: cubic-bezier(0.055, 0.025, 0.385, 0.985);
  }
  43.333333% {
    transform: rotate(0deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.005, 1);
  }
  50% {
    transform: rotate(0deg);
    animation-timing-function: cubic-bezier(0.345, 0.01, 0.26, 0.995);
  }
  60% {
    transform: rotate(1.295493deg);
    animation-timing-function: cubic-bezier(0.055, 0.025, 0.385, 0.985);
  }
  68.333333% {
    transform: rotate(0deg);
    animation-timing-function: cubic-bezier(0.42, 0, 0.005, 1);
  }
  75% {
    transform: rotate(0deg);
    animation-timing-function: cubic-bezier(0.345, 0.01, 0.26, 0.995);
  }
  85% {
    transform: rotate(1.295493deg);
    animation-timing-function: cubic-bezier(0.055, 0.025, 0.385, 0.985);
  }
  93.333333% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
#eRU21YPxKsw68-fill-0 {
  animation: eRU21YPxKsw68-fill-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw68-fill-0__c {
  0% {
    stop-color: rgb(52, 165, 148);
  }
  10% {
    stop-color: rgb(52, 67, 148);
  }
  25% {
    stop-color: rgb(52, 67, 148);
  }
  35% {
    stop-color: rgb(214, 0, 93);
  }
  50% {
    stop-color: rgb(214, 0, 93);
  }
  60% {
    stop-color: rgb(255, 141, 54);
  }
  75% {
    stop-color: rgb(255, 141, 54);
  }
  85% {
    stop-color: rgb(52, 165, 148);
  }
  100% {
    stop-color: rgb(52, 165, 148);
  }
}
#eRU21YPxKsw68-fill-1 {
  animation: eRU21YPxKsw68-fill-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw68-fill-1__c {
  0% {
    stop-color: rgb(157, 209, 129);
  }
  10% {
    stop-color: rgb(74, 185, 194);
  }
  25% {
    stop-color: rgb(74, 185, 194);
  }
  35% {
    stop-color: rgb(255, 164, 122);
  }
  50% {
    stop-color: rgb(255, 164, 122);
  }
  60% {
    stop-color: rgb(255, 234, 148);
  }
  75% {
    stop-color: rgb(255, 234, 148);
  }
  85% {
    stop-color: rgb(157, 209, 129);
  }
  100% {
    stop-color: rgb(157, 209, 129);
  }
}
#eRU21YPxKsw69-fill-0 {
  animation: eRU21YPxKsw69-fill-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw69-fill-0__c {
  0% {
    stop-color: rgb(40, 128, 143);
  }
  10% {
    stop-color: rgb(38, 36, 125);
  }
  25% {
    stop-color: rgb(38, 36, 125);
  }
  35% {
    stop-color: rgb(163, 0, 87);
  }
  50% {
    stop-color: rgb(163, 0, 87);
  }
  60% {
    stop-color: rgb(252, 104, 102);
  }
  75% {
    stop-color: rgb(252, 104, 102);
  }
  85% {
    stop-color: rgb(40, 128, 143);
  }
  100% {
    stop-color: rgb(40, 128, 143);
  }
}
#eRU21YPxKsw69-fill-1 {
  animation: eRU21YPxKsw69-fill-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw69-fill-1__c {
  0% {
    stop-color: rgb(74, 197, 119);
  }
  10% {
    stop-color: rgb(48, 147, 189);
  }
  25% {
    stop-color: rgb(48, 147, 189);
  }
  35% {
    stop-color: rgb(255, 60, 85);
  }
  50% {
    stop-color: rgb(255, 60, 85);
  }
  60% {
    stop-color: rgb(255, 160, 71);
  }
  75% {
    stop-color: rgb(255, 160, 71);
  }
  85% {
    stop-color: rgb(74, 197, 119);
  }
  100% {
    stop-color: rgb(74, 197, 119);
  }
}
#eRU21YPxKsw70-fill-0 {
  animation: eRU21YPxKsw70-fill-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw70-fill-0__c {
  0% {
    stop-color: rgba(39, 130, 233, 0);
  }
  10% {
    stop-color: rgba(233, 70, 214, 0);
  }
  25% {
    stop-color: rgba(233, 70, 214, 0);
  }
  35% {
    stop-color: rgba(225, 255, 148, 0);
  }
  50% {
    stop-color: rgba(225, 255, 148, 0);
  }
  60% {
    stop-color: rgba(207, 41, 162, 0);
  }
  75% {
    stop-color: rgba(207, 41, 162, 0);
  }
  85% {
    stop-color: rgba(39, 130, 233, 0);
  }
  100% {
    stop-color: rgba(39, 130, 233, 0);
  }
}
#eRU21YPxKsw70-fill-1 {
  animation: eRU21YPxKsw70-fill-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw70-fill-1__c {
  0% {
    stop-color: rgb(39, 130, 233);
  }
  10% {
    stop-color: rgb(233, 70, 214);
  }
  25% {
    stop-color: rgb(233, 70, 214);
  }
  35% {
    stop-color: rgb(225, 255, 148);
  }
  50% {
    stop-color: rgb(225, 255, 148);
  }
  60% {
    stop-color: rgb(207, 41, 162);
  }
  75% {
    stop-color: rgb(207, 41, 162);
  }
  85% {
    stop-color: rgb(39, 130, 233);
  }
  100% {
    stop-color: rgb(39, 130, 233);
  }
}
#eRU21YPxKsw71 {
  animation: eRU21YPxKsw71__m 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw71__m {
  0% {
    d: path(
      "M703.26,595.72C728.989661,597.47328,760.458079,597.68816,810.11,596.22L824.34,593.72"
    );
    animation-timing-function: cubic-bezier(0.18, 0.115, 0.16, 1);
  }
  10% {
    d: path(
      "M679.175813,592.402499C715.685813,601.242499,748.11,593.43,810.11,596.22L824.34,593.72"
    );
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  18.333333% {
    d: path(
      "M703.26,595.72C728.989661,597.47328,760.458079,597.68816,810.11,596.22L824.34,593.72"
    );
    animation-timing-function: cubic-bezier(0.18, 0.115, 0.16, 1);
  }
  25% {
    d: path(
      "M703.26,595.72C728.989661,597.47328,760.458079,597.68816,810.11,596.22L824.34,593.72"
    );
    animation-timing-function: cubic-bezier(0.18, 0.115, 0.16, 1);
  }
  35% {
    d: path(
      "M679.175813,592.402499C715.685813,601.242499,748.11,593.43,810.11,596.22L824.34,593.72"
    );
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  43.333333% {
    d: path(
      "M703.26,595.72C728.989661,597.47328,760.458079,597.68816,810.11,596.22L824.34,593.72"
    );
    animation-timing-function: cubic-bezier(0.18, 0.115, 0.16, 1);
  }
  50% {
    d: path(
      "M703.26,595.72C728.989661,597.47328,760.458079,597.68816,810.11,596.22L824.34,593.72"
    );
    animation-timing-function: cubic-bezier(0.18, 0.115, 0.16, 1);
  }
  60% {
    d: path(
      "M679.175813,592.402499C715.685813,601.242499,748.11,593.43,810.11,596.22L824.34,593.72"
    );
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  68.333333% {
    d: path(
      "M703.26,595.72C728.989661,597.47328,760.458079,597.68816,810.11,596.22L824.34,593.72"
    );
    animation-timing-function: cubic-bezier(0.18, 0.115, 0.16, 1);
  }
  75% {
    d: path(
      "M703.26,595.72C728.989661,597.47328,760.458079,597.68816,810.11,596.22L824.34,593.72"
    );
    animation-timing-function: cubic-bezier(0.18, 0.115, 0.16, 1);
  }
  85% {
    d: path(
      "M679.175813,592.402499C715.685813,601.242499,748.11,593.43,810.11,596.22L824.34,593.72"
    );
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  93.333333% {
    d: path(
      "M703.26,595.72C728.989661,597.47328,760.458079,597.68816,810.11,596.22L824.34,593.72"
    );
  }
  100% {
    d: path(
      "M703.26,595.72C728.989661,597.47328,760.458079,597.68816,810.11,596.22L824.34,593.72"
    );
  }
}
#eRU21YPxKsw71-stroke-0 {
  animation: eRU21YPxKsw71-stroke-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw71-stroke-0__c {
  0% {
    stop-color: rgb(40, 128, 143);
  }
  10% {
    stop-color: rgb(38, 36, 125);
  }
  25% {
    stop-color: rgb(38, 36, 125);
  }
  35% {
    stop-color: rgb(163, 0, 87);
  }
  50% {
    stop-color: rgb(163, 0, 87);
  }
  60% {
    stop-color: rgb(252, 104, 102);
  }
  75% {
    stop-color: rgb(252, 104, 102);
  }
  85% {
    stop-color: rgb(40, 128, 143);
  }
  100% {
    stop-color: rgb(40, 128, 143);
  }
}
#eRU21YPxKsw71-stroke-1 {
  animation: eRU21YPxKsw71-stroke-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw71-stroke-1__c {
  0% {
    stop-color: rgb(52, 165, 148);
  }
  10% {
    stop-color: rgb(52, 67, 148);
  }
  25% {
    stop-color: rgb(52, 67, 148);
  }
  35% {
    stop-color: rgb(214, 0, 93);
  }
  50% {
    stop-color: rgb(214, 0, 93);
  }
  60% {
    stop-color: rgb(255, 141, 54);
  }
  75% {
    stop-color: rgb(255, 141, 54);
  }
  85% {
    stop-color: rgb(52, 165, 148);
  }
  100% {
    stop-color: rgb(52, 165, 148);
  }
}
#eRU21YPxKsw71-stroke-2 {
  animation: eRU21YPxKsw71-stroke-2__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw71-stroke-2__c {
  0% {
    stop-color: rgb(40, 128, 143);
  }
  10% {
    stop-color: rgb(38, 36, 125);
  }
  25% {
    stop-color: rgb(38, 36, 125);
  }
  35% {
    stop-color: rgb(163, 0, 87);
  }
  50% {
    stop-color: rgb(163, 0, 87);
  }
  60% {
    stop-color: rgb(252, 104, 102);
  }
  75% {
    stop-color: rgb(252, 104, 102);
  }
  85% {
    stop-color: rgb(40, 128, 143);
  }
  100% {
    stop-color: rgb(40, 128, 143);
  }
}
#eRU21YPxKsw72 {
  animation: eRU21YPxKsw72_f_p 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw72_f_p {
  0% {
    fill: rgb(40, 128, 143);
  }
  10% {
    fill: rgb(38, 36, 125);
  }
  25% {
    fill: rgb(38, 36, 125);
  }
  35% {
    fill: rgb(163, 0, 87);
  }
  50% {
    fill: rgb(163, 0, 87);
  }
  60% {
    fill: rgb(252, 104, 102);
  }
  75% {
    fill: rgb(252, 104, 102);
  }
  85% {
    fill: rgb(40, 128, 143);
  }
  100% {
    fill: rgb(40, 128, 143);
  }
}
#eRU21YPxKsw76-fill-0 {
  animation: eRU21YPxKsw76-fill-0__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw76-fill-0__c {
  0% {
    stop-color: rgb(173, 214, 146);
  }
  10% {
    stop-color: rgb(146, 214, 196);
  }
  25% {
    stop-color: rgb(146, 214, 196);
  }
  35% {
    stop-color: rgb(237, 183, 183);
  }
  50% {
    stop-color: rgb(237, 183, 183);
  }
  60% {
    stop-color: rgb(237, 211, 183);
  }
  75% {
    stop-color: rgb(237, 211, 183);
  }
  85% {
    stop-color: rgb(173, 214, 146);
  }
  100% {
    stop-color: rgb(173, 214, 146);
  }
}
#eRU21YPxKsw76-fill-1 {
  animation: eRU21YPxKsw76-fill-1__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw76-fill-1__c {
  0% {
    stop-color: rgb(140, 186, 166);
  }
  10% {
    stop-color: rgb(140, 181, 186);
  }
  25% {
    stop-color: rgb(140, 181, 186);
  }
  35% {
    stop-color: rgb(255, 185, 152);
  }
  50% {
    stop-color: rgb(255, 185, 152);
  }
  60% {
    stop-color: rgb(217, 194, 131);
  }
  75% {
    stop-color: rgb(217, 194, 131);
  }
  85% {
    stop-color: rgb(140, 186, 166);
  }
  100% {
    stop-color: rgb(140, 186, 166);
  }
}
#eRU21YPxKsw76-fill-2 {
  animation: eRU21YPxKsw76-fill-2__c 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw76-fill-2__c {
  0% {
    stop-color: rgb(236, 143, 101);
  }
  10% {
    stop-color: rgb(206, 86, 123);
  }
  25% {
    stop-color: rgb(206, 86, 123);
  }
  35% {
    stop-color: rgb(117, 188, 158);
  }
  50% {
    stop-color: rgb(117, 188, 158);
  }
  60% {
    stop-color: rgb(109, 210, 247);
  }
  75% {
    stop-color: rgb(109, 210, 247);
  }
  85% {
    stop-color: rgb(236, 143, 101);
  }
  100% {
    stop-color: rgb(236, 143, 101);
  }
}
#eRU21YPxKsw77 {
  animation: eRU21YPxKsw77__m 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw77__m {
  0% {
    d: path(
      "M763.85,512.78C747.07,516.57,738.41,517.87,717.49,519.28C738.41,513.47,747.07,512.78,763.85,512.78Z"
    );
    animation-timing-function: cubic-bezier(0.18, 0.115, 0.16, 1);
  }
  10% {
    d: path(
      "M763.85,512.78C747.005773,512.901245,735.028075,513.970253,717.49,519.28C732.668007,510.665425,751.320281,509.149571,763.85,512.78Z"
    );
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  18.333333% {
    d: path(
      "M763.85,512.78C747.07,516.57,738.41,517.87,717.49,519.28C738.41,513.47,747.07,512.78,763.85,512.78Z"
    );
    animation-timing-function: cubic-bezier(0.18, 0.115, 0.16, 1);
  }
  25% {
    d: path(
      "M763.85,512.78C747.07,516.57,738.41,517.87,717.49,519.28C738.41,513.47,747.07,512.78,763.85,512.78Z"
    );
    animation-timing-function: cubic-bezier(0.18, 0.115, 0.16, 1);
  }
  35% {
    d: path(
      "M763.85,512.78C747.005773,512.901245,735.028075,513.970253,717.49,519.28C732.668007,510.665425,751.320281,509.149571,763.85,512.78Z"
    );
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  43.333333% {
    d: path(
      "M763.85,512.78C747.07,516.57,738.41,517.87,717.49,519.28C738.41,513.47,747.07,512.78,763.85,512.78Z"
    );
    animation-timing-function: cubic-bezier(0.18, 0.115, 0.16, 1);
  }
  50% {
    d: path(
      "M763.85,512.78C747.07,516.57,738.41,517.87,717.49,519.28C738.41,513.47,747.07,512.78,763.85,512.78Z"
    );
    animation-timing-function: cubic-bezier(0.18, 0.115, 0.16, 1);
  }
  60% {
    d: path(
      "M763.85,512.78C747.005773,512.901245,735.028075,513.970253,717.49,519.28C732.668007,510.665425,751.320281,509.149571,763.85,512.78Z"
    );
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  68.333333% {
    d: path(
      "M763.85,512.78C747.07,516.57,738.41,517.87,717.49,519.28C738.41,513.47,747.07,512.78,763.85,512.78Z"
    );
    animation-timing-function: cubic-bezier(0.18, 0.115, 0.16, 1);
  }
  75% {
    d: path(
      "M763.85,512.78C747.07,516.57,738.41,517.87,717.49,519.28C738.41,513.47,747.07,512.78,763.85,512.78Z"
    );
    animation-timing-function: cubic-bezier(0.18, 0.115, 0.16, 1);
  }
  85% {
    d: path(
      "M763.85,512.78C747.005773,512.901245,735.028075,513.970253,717.49,519.28C732.668007,510.665425,751.320281,509.149571,763.85,512.78Z"
    );
    animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
  }
  93.333333% {
    d: path(
      "M763.85,512.78C747.07,516.57,738.41,517.87,717.49,519.28C738.41,513.47,747.07,512.78,763.85,512.78Z"
    );
  }
  100% {
    d: path(
      "M763.85,512.78C747.07,516.57,738.41,517.87,717.49,519.28C738.41,513.47,747.07,512.78,763.85,512.78Z"
    );
  }
}
#eRU21YPxKsw80 {
  animation: eRU21YPxKsw80_c_o 12000ms linear infinite normal forwards;
}
@keyframes eRU21YPxKsw80_c_o {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 0.5;
  }
  18.333333% {
    opacity: 0;
  }
  25% {
    opacity: 0;
  }
  35% {
    opacity: 0.5;
  }
  43.333333% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  60% {
    opacity: 0.5;
  }
  68.333333% {
    opacity: 0;
  }
  75% {
    opacity: 0;
  }
  85% {
    opacity: 0.5;
  }
  93.333333% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#eRU21YPxKsw81 {
  animation-name: eRU21YPxKsw81_c_o, eRU21YPxKsw81_f_p;
  animation-duration: 12000ms;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
  animation-direction: normal;
  animation-iteration-count: infinite;
}
@keyframes eRU21YPxKsw81_c_o {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 0.3;
  }
  18.333333% {
    opacity: 0;
  }
  25% {
    opacity: 0;
  }
  35% {
    opacity: 0.3;
  }
  43.333333% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  60% {
    opacity: 0.3;
  }
  68.333333% {
    opacity: 0;
  }
  75% {
    opacity: 0;
  }
  85% {
    opacity: 0.3;
  }
  93.333333% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
@keyframes eRU21YPxKsw81_f_p {
  0% {
    fill: rgb(1, 237, 255);
    animation-timing-function: step-end;
  }
  25% {
    fill: rgb(255, 170, 55);
  }
  75% {
    fill: rgb(248, 255, 85);
  }
  100% {
    fill: rgb(248, 255, 85);
  }
}
</style>
